if(typeof(ReflektionHelperJS) == "undefined" || ReflektionHelperJS == null || !ReflektionHelperJS){
	var ReflektionHelperJS = (function(){
		var LOCALSTORAGE_REFLEKTION_API_KEY = "reflektion_api_accesstoken",
		widgetsFiredForRecommetnaions=[],
		productIdToFetchPrice=[],
		solrProductPriceMap={},
		cookieKeyRfkAccessToken= "RFK_ACCESS_TOKEN",			
		REFLEKTION_ACCESS_TOKEN="",
		IS_KEY_RETRIVED=false,
		REFLEKTION_API_URL_HOST="",
		REFLEKTION_GET_ACCESS_TOKEN_URL="",
		REFLEKTION_API_HOST="",
		REFLEKTION_API_TIMEOUT="",
		REFLEKTION_SKU_PARTNUM_FIELD = "sku_partnumber",
		DEFINING_ATTRIBUTE_PREFIX = 'ptc_omni',
		reflectionAutoCompleteRequests={},		
		DEFINING_ATTRIBUTE_LIST=["ptc_omni_item_weight","ptc_omni_pkg_quantity","ptc_omni_size","ptc_omni_wattage_max","ptc_omni_item_height","ptc_omni_item_length","ptc_omni_item_width","ptc_omni_vol","ptc_omni_finish","ptc_omni_full_dims","ptc_omni_gallons_hr","ptc_omni_amount","ptc_omni_length","ptc_omni_pet_weight_min","ptc_omni_item_circumference","ptc_omni_item_depth","ptc_omni_petsize"],		
		rfkRecommendationRequest = {},
		recommendationParsedSkuDetails = {},
		recommendationWidgetProcessed = "",
		USER_CONTEXT = {},
		RECOMMENDATION_PDP_SKU="",
		AUTOCOMPLETE_PREVIOUS_SEARCH_TERM=" ",
		IS_AUTOCOMPLETE_DATA_FETCHED=false,
		RFKIDMAP={},
		ENABLE_REFLEKTION=false,
		retrievedCachedSuggestions=false,
		CachedSuggestionsURL="",
		isCallInitialtedForSOlr=false;
		SEARCH_SOURCE_KEY = "search_source";

				function accessTokenFromLocalStorage(){
			var isExistsInlocal = false;
			 getReflektionApiUrl();
			 getReflektionHostApiUrl();
			 getReflektionEnabled();
			 getReflektionTimeOut();
			 var accessTokenLocalstorage = localStorage.getItem(LOCALSTORAGE_REFLEKTION_API_KEY);
			 var accessTokenJSON;
				if(accessTokenLocalstorage != null){
					accessTokenJSON = JSON.parse(accessTokenLocalstorage);
					var accessExpiryTime = accessTokenJSON.expiryTime;
					var currentTime = new Date().getTime();
					if(currentTime > accessExpiryTime){
						isExistsInlocal = false;
					}else{
						isExistsInlocal = true;
						REFLEKTION_ACCESS_TOKEN = accessTokenJSON.accessToken;
						IS_KEY_RETRIVED=true;
						setReflektionCookies();
					}
				}else{
					isExistsInlocal = false;
				}
				if(!isExistsInlocal && REFLEKTION_GET_ACCESS_TOKEN_URL != "" ){
					var URL = REFLEKTION_GET_ACCESS_TOKEN_URL,
					dataScope = '{"scope":["search-rec"]}';
					$.ajax({
							url : URL,
							type: 'POST',
							data: dataScope,
							beforeSend : function(xhr){ 
								xhr.setRequestHeader('Content-Type', 'application/json');     
							}, 
							success : function(data) { 
								var ApiAccessResponse ={};
								ApiAccessResponse.accessToken = data.accessToken;
								ApiAccessResponse.expiryTime = new Date(data.accessTokenExpiryDate).getTime();
								REFLEKTION_ACCESS_TOKEN =  data.accessToken;
								IS_KEY_RETRIVED=true;
								localStorage.setItem(LOCALSTORAGE_REFLEKTION_API_KEY, JSON.stringify(ApiAccessResponse));
								setReflektionCookies();
							},dataType : 'json', 
								error : function(jqXHR, textStatus, errorThrown) {
									REFLEKTION_ACCESS_TOKEN = "";
									removeCookie(cookieKeyRfkAccessToken);
									IS_KEY_RETRIVED=true;
								}    
						}); 
					}
		}

				function setReflektionCookies(){
			removeCookie(cookieKeyRfkAccessToken);
			var accessTokenDetails = JSON.parse(localStorage.getItem(LOCALSTORAGE_REFLEKTION_API_KEY));
			setCookie(cookieKeyRfkAccessToken, accessTokenDetails.accessToken, {path:'/'});			
		}

			function getReflektionApiUrl(){
			var apiUrlObj = $("#REFLEKTION_HOST_URL");
			if(apiUrlObj.length > 0){
				REFLEKTION_API_URL_HOST = $(apiUrlObj).val();
			}
		}
		function getReflektionHostApiUrl(){
			var apiUrlObj = $("#REFLEKTION_GET_ACCESS_TOKEN_URL");
			if(apiUrlObj.length > 0){
				REFLEKTION_GET_ACCESS_TOKEN_URL = $(apiUrlObj).val();
			}
			if(REFLEKTION_GET_ACCESS_TOKEN_URL == ""){
				var storeId= $("#storeId").val();
				if(storeId !=""){
					REFLEKTION_GET_ACCESS_TOKEN_URL = "";
				}
			}
		}

		function getReflektionTimeOut(){
			var apiUrlObj = $("#REFLEKTION_API_TIMEOUT");
			if(apiUrlObj.length > 0){
				REFLEKTION_API_TIMEOUT = $(apiUrlObj).val();
			}
		}
		function getReflektionEnabled(){
			var isReflektionEnabled = $("#ENABLE_REFLEKTION");
			if(isReflektionEnabled.length > 0){
				ENABLE_REFLEKTION = true;
			}
		}
		function showAutoSuggest_RFL(decission){
			if(decission){
				$("#look-ahead").addClass("active");
			}else{
				$("#look-ahead").removeClass("active");
			}
		}
		function autoComplete_init(){
			getReflektionEnabled();
			if(typeof(document.CatalogSearchForm) != "undefined" 
				&& typeof(document.CatalogSearchForm.searchTerm) != "undefined" && ENABLE_REFLEKTION){
				$(document.CatalogSearchForm.searchTerm).on("click keyup blur", function(event) {
					var autoSuggestCall = setInterval(function(){ 
						if(IS_KEY_RETRIVED){
							clearInterval(autoSuggestCall);
							if(event.type == "blur"){
								setTimeout(function(){showAutoSuggest_RFL(false)},800)
							}else if(event.type == "keyup" && event.keyCode == 13){
								if (ReflektionHelperJS.checkBeforeSearchSubmit()) {
									document.CatalogSearchForm.submit();
								}
								return;
							}else{
								reflextion_populateAutoComplete();
							}

													}
					}, 100);

									});

							}
		}
		function reflextion_populateAutoComplete(){
			var searchTerm = document.CatalogSearchForm.searchTerm.value.trim();
			if(searchTerm.length > 1){
				reflextion_populateAutoCompleteFromSrchTerm(searchTerm);
			}else{
				reflextion_populateAutoCompleteFromSrchTerm("");
			}
			retrieveCachedSuggestions();
		}
		function reflextion_populateAutoCompleteFromSrchTerm(srchTerm){
			if(AUTOCOMPLETE_PREVIOUS_SEARCH_TERM == srchTerm){
				if(IS_AUTOCOMPLETE_DATA_FETCHED){
					$("#look-ahead").addClass("active");
				}
				return;
			}
			var noOfProductsToBefetched = 6;
			if($("#noofproducts").length > 0){
				noOfProductsToBefetched = $("#noofproducts").val()*1;
			}
			reflectionAutoCompleteRequests.data.n_item = noOfProductsToBefetched;
			AUTOCOMPLETE_PREVIOUS_SEARCH_TERM = srchTerm;
			reflectionAutoCompleteRequests.data.query.keyphrase.value = [];
			if(srchTerm!=""){
				reflectionAutoCompleteRequests.data.query.keyphrase.value.push(srchTerm);
			}
			var widgetAutoComplete="";	
			if($("#REFLEKTION_RFKID_AUTOCOMPLETE").length > 0){
				widgetAutoComplete = $("#REFLEKTION_RFKID_AUTOCOMPLETE").val();
			}
			reflectionAutoCompleteRequests.data.widget.rfkid = widgetAutoComplete;

					      var uuid="RFK_UUID";
	        	if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) != 'undefined' && typeof(rfk.uid) == 'function'){
	        		uuid = rfk.uid();
	        	}
	        	reflectionAutoCompleteRequests.data.context.user.uuid = uuid;



												var URL = "//"+REFLEKTION_API_URL_HOST;
			$.ajax(
					{
						url : URL,
						type: 'POST',
						data: JSON.stringify(reflectionAutoCompleteRequests),
						 headers: {"Authorization": "Bearer "+REFLEKTION_ACCESS_TOKEN},
						beforeSend : function(xhr){ 
							xhr.setRequestHeader('Content-Type', 'application/json');     
						}, 
						success : function(dataVal) {
							var isNewEASession = getCookie('isNewEASession');
							if (isNewEASession!=null && isNewEASession == "yes" ){
								load_EAReflektion_autocomplete(dataVal,srchTerm);
							}else{
								load_Reflektion_autocomplete(dataVal,srchTerm);
								ReflektionHelperJS.bopusAreaRestrictionCheck();
							}
						},
						dataType : 'json',
						error : function(jqXHR, textStatus, errorThrown) { 
							clear_Reflektion_autocomplete();       
						}     
					}
				);

					}
		function load_Reflektion_autocomplete(jsonObject,searchTerm){
			IS_AUTOCOMPLETE_DATA_FETCHED = true;
			var isCategoryExists =false;
			var lowerCaseSearchTerm = searchTerm.toLowerCase();
			var htmlCategoryContentItemLevel = "";
			var htmlContent = "";
			$("#reflektion_autocomplete_brand_emptybox").addClass("hide");
			$("#reflektion_autocomplete_searchterm_emptybox").addClass("hide");
			var RFLK_SEE_ALL = $("#RFLK_SEE_ALL").val();
			var RFLK_SEE_ALL_TRENDING_PRODUCTS = $("#RFLK_SEE_ALL_TRENDING_PRODUCTS").val();
			var RFLK_TOP_PRODUCTS = $("#RFLK_TOP_PRODUCTS").val();
			var RFLK_TRENDING_PRODUCTS = $("#RFLK_TRENDING_PRODUCTS").val();
			var RFLK_RELATED_SEARCH = $("#RFLK_RELATED_SEARCH").val();
			var RFLK_TOP_BRANDS = $("#RFLK_TOP_BRANDS").val();
			var RFLK_TRENDING_CATEGORIES = $("#RFLK_TRENDING_CATEGORIES").val();
			var RFLK_TOP_CATEGORIES = $("#RFLK_TOP_CATEGORIES").val();
			var is_bopus_area_restriction_req = "";

						var categoryTrackingLisnk ="";
			if(searchTerm != ""){
				categoryTrackingLisnk ="PreviewSearch-_-TopCategories:";
				if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.suggestion) != 'undefined' && typeof(jsonObject.suggestion.category) != 'undefined' ){
					for(var i in jsonObject.suggestion.category){
						isCategoryExists = true;
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<li id='categoryItem_"+i+"' role='listitem' tabindex='-1'>";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<a manual_cm_sp='"+categoryTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.suggestion.category[i].text.split(" ").join("")+"' onclick='clickTrackLink(this);' role='listitem' href='"+formSearchPreviewUrl(document.domain+jsonObject.suggestion.category[i].url)+"' onmouseout='this.className=\"\"' "
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+" title='"+jsonObject.suggestion.category[i].text+"'";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+" id='category_autoSelectOption_"+i+"'>"
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+ jsonObject.suggestion.category[i].text.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+'</a></li>';
					}
				}
				if(isCategoryExists){
	 				htmlContent = "<div id='topCategoryResults'><div id='topCategoryResults_header'><strong>"+RFLK_TOP_CATEGORIES+"</strong>";
	 				htmlContent = htmlContent+"<div class='list_section'>";
	 				htmlContent = htmlContent+"<div title='Category' role='list'>";
	 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
	 				htmlContent = htmlContent+htmlCategoryContentItemLevel;
	 				htmlContent = htmlContent+"</ul></div></div></div></div>";
	 				$("#reflektion_autocomplete_category").html(htmlContent);
	 				$("#reflektion_autocomplete_category").show();
	 				$("#reflektion_autocomplete_category").addClass("show");
	 				$("#look-ahead").addClass("active");
	 			}else{
	 				if(searchTerm != ""){
		 				$("#reflektion_autocomplete_category").hide();
		 				$("#reflektion_autocomplete_category").removeClass("show");
		 				$("#reflektion_autocomplete_category").html("");
	 				}
	 			}
			}


									if(searchTerm == ""){
				categoryTrackingLisnk ="PreviewSearch-_-TrendingCategories:";
				if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.suggestion) != 'undefined' && typeof(jsonObject.suggestion.trending_category) != 'undefined' ){
					for(var i in jsonObject.suggestion.trending_category){
						isCategoryExists = true;
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<li id='categoryItem_"+i+"' role='listitem' tabindex='-1'>";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"<a manual_cm_sp='"+categoryTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.suggestion.trending_category[i].text.split(" ").join("")+"' onclick='clickTrackLink(this);' role='listitem' href='"+formSearchPreviewUrl(document.domain+jsonObject.suggestion.trending_category[i].url)+"' onmouseout='this.className=\"\"' "
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+"  title='"+jsonObject.suggestion.trending_category[i].text+"'";
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+" id='category_autoSelectOption_"+i+"'>"
		 				htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+ jsonObject.suggestion.trending_category[i].text.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
						htmlCategoryContentItemLevel = htmlCategoryContentItemLevel+'</a></li>';
					}
				}
				if(isCategoryExists){
	 				htmlContent = "<div id='topCategoryResults'><div id='topCategoryResults_header'><strong>"+RFLK_TRENDING_CATEGORIES+"</strong>";
	 				htmlContent = htmlContent+"<div class='list_section'>";
	 				htmlContent = htmlContent+"<div title='Category' role='list'>";
	 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
	 				htmlContent = htmlContent+htmlCategoryContentItemLevel;
	 				htmlContent = htmlContent+"</ul></div></div></div></div>";
	 				$("#reflektion_autocomplete_category").html(htmlContent);
	 				$("#reflektion_autocomplete_category").show();
	 				$("#reflektion_autocomplete_category").addClass("show");
	 				$("#look-ahead").addClass("active");
	 			}else{
	 				if(searchTerm != ""){
	 				$("#reflektion_autocomplete_category").hide();
	 				$("#reflektion_autocomplete_category").removeClass("show");
	 				$("#reflektion_autocomplete_category").html("");
	 				}
	 			}
			}
			var brandTrackingLisnk="PreviewSearch-_-TopBrands:";
			var isBrandExists =false;
			var htmlBrandContentItemLevel = "";
			htmlContent = "";
			if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.suggestion) != 'undefined' && typeof(jsonObject.suggestion.brand) != 'undefined' ){
				for(var i in jsonObject.suggestion.brand){
					isBrandExists = true;
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<li id='brandItem_"+i+"' role='listitem' tabindex='-1'>";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<a manual_cm_sp='"+brandTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.suggestion.brand[i].text.split(" ").join("")+"' onclick='clickTrackLink(this);' role='listitem' href='//"+document.domain+jsonObject.suggestion.brand[i].url+"' onmouseout='this.className=\"\"' "
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" title='"+jsonObject.suggestion.brand[i].text+"'";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" id='brand_autoSelectOption_"+i+"'>"
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+ jsonObject.suggestion.brand[i].text.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+'</a></li>';
				}
			}
			if(isBrandExists){
 				htmlContent = "<div id='topBrandResults'><div id='topBrandResults_header'><strong>"+RFLK_TOP_BRANDS+"</strong>";
 				htmlContent = htmlContent+"<div class='list_section'>";
 				htmlContent = htmlContent+"<div title='Brand' role='list'>";
 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
 				htmlContent = htmlContent+htmlBrandContentItemLevel;
 				htmlContent = htmlContent+"</ul></div></div></div></div>";
 				$("#reflektion_autocomplete_brand").html(htmlContent);
 				$("#reflektion_autocomplete_brand").show();
 				$("#reflektion_autocomplete_brand").addClass("show");
 				$("#look-ahead").addClass("active");
 			}else{
 				if(searchTerm != ""){
 				$("#reflektion_autocomplete_brand").hide();
 				$("#reflektion_autocomplete_brand").removeClass("show");
 				$("#reflektion_autocomplete_brand").html("");
 				}
 			}
			var relatedSearchesTrackingLisnk="PreviewSearch-_-RelatedSearches:";
			var isSearchTermExists =false;
						var htmlSearchTermContentItemLevel = "";
						htmlContent = "";
						if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.suggestion) != 'undefined' && typeof(jsonObject.suggestion.keyphrase) != 'undefined' ){
							for(var i in jsonObject.suggestion.keyphrase){
								if(jsonObject.suggestion.keyphrase[i].text.trim() !=""){
								isSearchTermExists = true;
								htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+"<li id='searchtermItem_"+i+"' role='listitem' tabindex='-1'>";
				 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+"<a manual_cm_sp='"+relatedSearchesTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.suggestion.keyphrase[i].text.split(" ").join("")+"'   role='listitem' href='#' onmouseout='this.className=\"\"' "
				 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+" onmouseover='SearchJS.enableAutoSelect(\""+i+"\");'  ";
				 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+" onclick='clickTrackLink(this);SearchJS.selectAutoSuggest(this.title); return false;' title='"+jsonObject.suggestion.keyphrase[i].text+"'";
				 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+" id='searchterm_autoSelectOption_"+i+"'>"
				 				htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+ jsonObject.suggestion.keyphrase[i].text;
								htmlSearchTermContentItemLevel = htmlSearchTermContentItemLevel+'</a></li>';
								}
							}
						}		

		 										if(isSearchTermExists){
			 				htmlContent = "<div id='topsearchtermResults'><div id='topsearchtermResults_header'><strong>"+RFLK_RELATED_SEARCH+"</strong>";
			 				htmlContent = htmlContent+"<div class='list_section'>";
			 				htmlContent = htmlContent+"<div title='Search Term' role='list'>";
			 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
			 				htmlContent = htmlContent+htmlSearchTermContentItemLevel;
			 				htmlContent = htmlContent+"</ul></div></div></div></div>";
			 				$("#reflektion_autocomplete_searchterm").html(htmlContent);
			 				$("#reflektion_autocomplete_searchterm").show();
			 				$("#reflektion_autocomplete_searchterm").addClass("show");
			 				$("#look-ahead").addClass("active");
			 			}else{
			 				if(searchTerm != ""){
			 				$("#reflektion_autocomplete_searchterm").hide();
			 				$("#reflektion_autocomplete_searchterm").removeClass("show");
			 				$("#reflektion_autocomplete_searchterm").html("");
			 				}
			 			}
						var productSearchesTrackingLisnk="PreviewSearch-_-TopProducts:";
						var isDataExistrs=false;
						if(jsonObject.content.product.total_item > 0){
						var htmlContentProduct = "<div class='row'>";

												if(searchTerm == ""){
							productSearchesTrackingLisnk="PreviewSearch-_-TrendingProducts:";
			 			htmlContentProduct = htmlContentProduct+"<div class='col-12'><strong>"+RFLK_TRENDING_PRODUCTS+"</strong></div></div>";
						}else{
							productSearchesTrackingLisnk="PreviewSearch-_-TopProducts:";
						htmlContentProduct = htmlContentProduct+"<div class='col-12'><strong>"+RFLK_TOP_PRODUCTS+"</strong></div></div>";	
						}
			 			htmlContentProduct = htmlContentProduct+"<div class='row'>";
			 			if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.content) != 'undefined' && typeof(jsonObject.content.product) != 'undefined' ){

			 							 			for(var i in jsonObject.content.product.value){
			 				if(typeof(jsonObject.content.product.value[i].swatch) != 'undefined' &&
			 						typeof(jsonObject.content.product.value[i].swatch[0].is_bopus_area_restriction_req) != 'undefined'){
			 					is_bopus_area_restriction_req = jsonObject.content.product.value[i].swatch[0].is_bopus_area_restriction_req;
			 				}else{
			 					is_bopus_area_restriction_req = "";
			 				}

			 							 				isDataExistrs=true;
			 				htmlContentProduct = htmlContentProduct+'<div manual_cm_sp="'+productSearchesTrackingLisnk+((i*1)+1)+'-_-'+jsonObject.content.product.value[i].sku.split(" ").join("")+'"  class="col-4 prod-tile-rfl" onclick="clickTrackLink(this);location.href=\'//'+document.domain+jsonObject.content.product.value[i].url+'\'">';
			 				if(typeof(jsonObject.content.product.value[i].listprice_USD) != 'undefined' && 
			 						(jsonObject.content.product.value[i].listprice_USD.replace("$","")*1) > jsonObject.content.product.value[i].final_price){
			 					htmlContentProduct = htmlContentProduct+'<img class="badge" src="/wcsstore/PetcoStore/img/ON_SALE.png"/>';
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-4-sm text-center " >';

			 											var ProductImageURL = jsonObject.content.product.value[i].image_url.replace("/wcsstore/PetcoCAS/","");
							var imagePresetSrc = ProductImageURL + '?$tile-recommendations$';
							var imagePresetSrcMobile = ProductImageURL + '?$PDP-thumbnail$';
							if (isCloudniaryEnabled()) {
								imagePresetSrc  = ProductImageURL.replace('f_auto,q_auto', 'f_auto,q_auto,t_tile-recommendations');
								imagePresetSrcMobile  = ProductImageURL.replace('f_auto,q_auto', 'f_auto,q_auto,t_PDP-thumbnail');
							}
			 				htmlContentProduct = htmlContentProduct+'<img class="desktop-only rfk-img-responsive" src="'+imagePresetSrc+'" title="'+jsonObject.content.product.value[i].name+'">';
			 				htmlContentProduct = htmlContentProduct+'<img class="mobile-only rfk-img-responsive" src="'+imagePresetSrcMobile+'" title="'+jsonObject.content.product.value[i].name+'">';
			 				htmlContentProduct = htmlContentProduct+'</div>';

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-8-sm text-left product-name" >';
			 				var brandName = jsonObject.content.product.value[i].brands[0];
			 				if(typeof(brandName) != 'undefined' && jsonObject.content.product.value[i].name.indexOf(brandName) ==0){
			 					htmlContentProduct = htmlContentProduct+"<strong>"+brandName+"</strong>";
			 					htmlContentProduct = htmlContentProduct+jsonObject.content.product.value[i].name.replace(brandName,"");
			 				}else{
			 					htmlContentProduct = htmlContentProduct+jsonObject.content.product.value[i].name;
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'</div>';
			 				if(typeof(is_bopus_area_restriction_req) != 'undefined' && is_bopus_area_restriction_req != "" && is_bopus_area_restriction_req.toLowerCase() == 'yes'){
			 					htmlContentProduct = htmlContentProduct+'<div class="col-8-sm mobile-only hideBopusAreaRestriction product-pricing rfk-product-pricing-mobile" >';
			 				}else{
			 					htmlContentProduct = htmlContentProduct+'<div class="col-8-sm mobile-only product-pricing rfk-product-pricing-mobile" >';
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">'+jsonObject.content.product.value[i].price_USD+'</span>';
			 				if(typeof(jsonObject.content.product.value[i].listprice_USD) != 'undefined' && 
			 						(jsonObject.content.product.value[i].listprice_USD.replace("$","")*1) > jsonObject.content.product.value[i].final_price){

			 								 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was'+jsonObject.content.product.value[i].listprice_USD+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</div>';			 				

			 							 				if(typeof(is_bopus_area_restriction_req) != 'undefined' &&  is_bopus_area_restriction_req != "" && is_bopus_area_restriction_req.toLowerCase() == 'yes'){
			 					htmlContentProduct = htmlContentProduct+'<div class="col-12  text-center desktop-only product-pricing hideBopusAreaRestriction" >';
			 				}else{
			 					htmlContentProduct = htmlContentProduct+'<div class="col-12  text-center desktop-only product-pricing" >';
			 				}
			 				var displayPrice="";
			 				if(typeof(jsonObject.content.product.value[i].final_price)!= 'undefined'){
			 					displayPrice=jsonObject.content.product.value[i].final_price;
			 					if(typeof(displayPrice)!= "string")
			 						displayPrice = displayPrice.toString();
			 					if(displayPrice.indexOf("$")==-1)
			 						displayPrice="$"+displayPrice;
			 				}
			 				else{
			 					displayPrice=jsonObject.content.product.value[i].listprice_USD;
			 				}
			 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">'+displayPrice+'</span>';
			 				if(typeof(jsonObject.content.product.value[i].listprice_USD) != 'undefined' && 
			 						(jsonObject.content.product.value[i].listprice_USD.replace("$","")*1) > jsonObject.content.product.value[i].final_price){
			 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was'+jsonObject.content.product.value[i].listprice_USD+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 			}
		}
			 			htmlContentProduct = htmlContentProduct+"</div>";
			 			htmlContentProduct =  htmlContentProduct+"<div class='row desktop-only'>";
			 			if(searchTerm == ""){

							}else{
								htmlContentProduct = htmlContentProduct+'<div class="col-2">&nbsp;</div><div class="col-8 text-center"><a href="javascript:document.CatalogSearchForm.submit()" class="btn btn-primary margin-bottom-sm btn-full" role="button">'+RFLK_SEE_ALL+'</a></div><div class="col-2"></div></div>';	
							}

			 									}else{
							if(searchTerm != ""){
			 				$("#productSuggestionResults_div").html("");
			 				$("#productSuggestionResults_div").hide();
			 				$("#productSuggestionResults_div").removeClass("show");
							}
			 			}
			 			if(isDataExistrs){
			 				$("#productSuggestionResults_div").show();
			 				$("#productSuggestionResults_div").addClass("show");
			 				$("#productSuggestionResults_div").html(htmlContentProduct);
			 				$("#look-ahead").addClass("active");
			 			}
						$("#reflektion_AutoCompleteList").addClass("show");
						$("#reflektion_AutoCompleteList").removeClass("hide");
						$("#reflektion_AutoCompleteList_empty").addClass("hide");
						$("#reflektion_AutoCompleteList_empty").removeClass("show");

			 						 			var isMobile = window.matchMedia("(max-width: 768px)").matches;
			 			if(!isMobile){
			 				setTimeout(function(){$(".prod-tile-rfl .product-name").dotdotdot();},25);
			 			}



			 						 										 			 var widthOfWindows = $(window).width()*0.50;
			 			if(($("#SimpleSearchForm_SearchTerm").width()*2) < widthOfWindows){
			 				widthOfWindows = $("#SimpleSearchForm_SearchTerm").width()*2;
			 			}
			 		    var heightOfWIndows = window.innerHeight-$("#header").height();
			 		   if($("#search.search.persist-active.active").length >0){
			 			  heightOfWIndows = heightOfWIndows - $("#search.search.persist-active.active").height();
			 		   }
			 			if(!isMobile){
			 				if($("#productSuggestionResults_div").height() > $("#infoPart").height()){
			 					$("#infoPart").height($("#productSuggestionResults_div").height());
			 				}else{
			 					$("#productSuggestionResults_div").height($("#infoPart").height());
			 				}
			 				if(($("#infoPart").height()+5) < heightOfWIndows){
			 					heightOfWIndows= $("#infoPart").height()+5;
			 				}
			 			    $("#look-ahead").width(widthOfWindows);
			 			    $("#look-ahead").height(heightOfWIndows);
			 			    $("#look-ahead").css("maxHeight",heightOfWIndows+"px");
			 				if($("#search.search.persist-active.active").length >0){
				 				$("#look-ahead").css("marginLeft","-"+($("#look-ahead").width()-($("#search.search.persist-active.active").width()))+"px");

				 								 			}else{
				 				$("#look-ahead").css("marginLeft","0px");
				 			}
			 			}else{

			 				 			 				 $("#look-ahead").width($(window).width());
				 			    $("#look-ahead").height((window.innerHeight-($("#header").height()+$("#search").height()))/2);
				 			   $("#look-ahead").css("maxHeight",(window.innerHeight-($("#header").height()+$("#search").height()))/2+"px");
			 			}
						if(lowerCaseSearchTerm == ""){
							$("#reflektion_autocomplete_brand").html($("#reflektion_autocomplete_brand_emptybox").html());
							$("#reflektion_autocomplete_searchterm").html($("#reflektion_autocomplete_searchterm_emptybox").html());
						}else{

														if(!$("#reflektion_autocomplete_category").hasClass("show")
									&& !$("#reflektion_autocomplete_brand").hasClass("show")
									&& !$("#reflektion_autocomplete_searchterm").hasClass("show")
									&& !$("#productSuggestionResults_div").hasClass("show")
									&& searchTerm != ""){
								$("#reflektion_AutoCompleteList_empty").addClass("show");
								$("#reflektion_AutoCompleteList_empty").removeClass("hide");
								$("#reflektion_AutoCompleteList").addClass("hide");
								$("#reflektion_AutoCompleteList").removeClass("show");

																if(!isMobile){
								$("#reflektion_AutoCompleteList_empty div.row div.col-12.emptyresult").html("<strong>No results for \""+searchTerm+"\"</strong>")
								}else{
									$("#reflektion_AutoCompleteList_empty div.row div.col-12.emptyresult").html("<strong>No results for \""+searchTerm.substring(0,150)+"\"</strong>")
								}
								$("#look-ahead").height($("#reflektion_AutoCompleteList_empty").height()*1.20);
							}
						}
		}

				function load_EAReflektion_autocomplete(jsonObject,searchTerm){
			IS_AUTOCOMPLETE_DATA_FETCHED = true;
			var isCategoryExists =false;
			var lowerCaseSearchTerm = searchTerm.toLowerCase();
			var htmlCategoryContentItemLevel = "";
			var htmlContent = "";
			$("#reflektion_autocomplete_brand_emptybox").addClass("hide");
			$("#reflektion_autocomplete_searchterm_emptybox").addClass("hide");
			var RFLK_SEE_ALL = $("#RFLK_SEE_ALL").val();
			var RFLK_SEE_ALL_TRENDING_PRODUCTS = $("#RFLK_SEE_ALL_TRENDING_PRODUCTS").val();
			var RFLK_TOP_PRODUCTS = $("#RFLK_TOP_PRODUCTS").val();
			var RFLK_TRENDING_PRODUCTS = $("#RFLK_TRENDING_PRODUCTS").val();
			var RFLK_RELATED_SEARCH = $("#RFLK_RELATED_SEARCH").val();
			var RFLK_TOP_BRANDS = $("#RFLK_TOP_BRANDS").val();
			var RFLK_TRENDING_CATEGORIES = $("#RFLK_TRENDING_CATEGORIES").val();
			var RFLK_TOP_CATEGORIES = $("#RFLK_TOP_CATEGORIES").val();

			var brandTrackingLisnk="PreviewSearch-_-TopBrands:";
			var isBrandExists =false;
			var htmlBrandContentItemLevel = "";
			htmlContent = "";
			if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.suggestion) != 'undefined' && typeof(jsonObject.suggestion.brand) != 'undefined' ){
				for(var i in jsonObject.suggestion.brand){
					isBrandExists = true;
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<li id='brandItem_"+i+"' role='listitem' tabindex='-1'>";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+"<a manual_cm_sp='"+brandTrackingLisnk+((i*1)+1)+"-_-"+jsonObject.suggestion.brand[i].text.split(" ").join("")+"' onclick=role='listitem' href='//"+(document.domain+jsonObject.suggestion.brand[i].url).replace('petcostore','petcoea')+"' onmouseout='this.className=\"\"' "
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" title='"+jsonObject.suggestion.brand[i].text+"'";
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+" id='brand_autoSelectOption_"+i+"'>"
	 				htmlBrandContentItemLevel = htmlBrandContentItemLevel+ jsonObject.suggestion.brand[i].text.replace(lowerCaseSearchTerm,"<span class='highlight'>"+searchTerm+"</span>")
					htmlBrandContentItemLevel = htmlBrandContentItemLevel+'</a></li>';
				}
			}
			if(isBrandExists){
 				htmlContent = "<div id='topBrandResults'><div id='topBrandResults_header'><strong>"+RFLK_TOP_BRANDS+"</strong>";
 				htmlContent = htmlContent+"<div class='list_section'>";
 				htmlContent = htmlContent+"<div title='Brand' role='list'>";
 				htmlContent = htmlContent+" <ul class='list-unstyled'>";
 				htmlContent = htmlContent+htmlBrandContentItemLevel;
 				htmlContent = htmlContent+"</ul></div></div></div></div>";
 				$("#reflektion_autocomplete_brand").html(htmlContent);
 				$("#reflektion_autocomplete_brand").show();
 				$("#reflektion_autocomplete_brand").addClass("show");
 				$("#look-ahead").addClass("active");
 			}else{
 				if(searchTerm != ""){
 				$("#reflektion_autocomplete_brand").hide();
 				$("#reflektion_autocomplete_brand").removeClass("show");
 				$("#reflektion_autocomplete_brand").html("");
 				}
 			}
						var productSearchesTrackingLisnk="PreviewSearch-_-TopProducts:";
						var isDataExistrs=false;
						if(jsonObject.content.product.total_item > 0){
						var htmlContentProduct = "<div class='row'>";

												if(searchTerm == ""){
							productSearchesTrackingLisnk="PreviewSearch-_-TrendingProducts:";
			 			htmlContentProduct = htmlContentProduct+"<div class='col-12'><strong>"+RFLK_TRENDING_PRODUCTS+"</strong></div></div>";
						}else{
							productSearchesTrackingLisnk="PreviewSearch-_-TopProducts:";
						htmlContentProduct = htmlContentProduct+"<div class='col-12'><strong>"+RFLK_TOP_PRODUCTS+"</strong></div></div>";	
						}
			 			htmlContentProduct = htmlContentProduct+"<div class='row'>";
			 			if(typeof(jsonObject) != 'undefined' && typeof(jsonObject.content) != 'undefined' && typeof(jsonObject.content.product) != 'undefined' ){

			 							 			for(var i in jsonObject.content.product.value){
			 				isDataExistrs=true;
			 				htmlContentProduct = htmlContentProduct+'<div manual_cm_sp="'+productSearchesTrackingLisnk+((i*1)+1)+'-_-'+jsonObject.content.product.value[i].sku.split(" ").join("")+'"  class="col-4 prod-tile-rfl" onclick="location.href=\'//'+(document.domain+jsonObject.content.product.value[i].url).replace('petcostore','petcoea')+'\'">';
			 				if(typeof(jsonObject.content.product.value[i].listprice_USD) != 'undefined' && 
			 						(jsonObject.content.product.value[i].listprice_USD.replace("$","")*1) > jsonObject.content.product.value[i].final_price){
			 					htmlContentProduct = htmlContentProduct+'<img class="badge" src="/wcsstore/PetcoStore/img/ON_SALE.png"/>';
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-4-sm text-center " >';
			 				var ProductImageURL = jsonObject.content.product.value[i].image_url.replace("/wcsstore/PetcoCAS/","");
							var imagePresetSrc = ProductImageURL + '?$tile-recommendations$';
							var imagePresetSrcMobile = ProductImageURL + '?$PDP-thumbnail$';
							if (isCloudniaryEnabled()) {
								imagePresetSrc  = ProductImageURL.replace('f_auto,q_auto', 'f_auto,q_auto,t_tile-recommendations');
								imagePresetSrcMobile  = ProductImageURL.replace('f_auto,q_auto', 'f_auto,q_auto,t_PDP-thumbnail');
							}
			 				htmlContentProduct = htmlContentProduct+'<img class="desktop-only rfk-img-responsive" src="'+imagePresetSrc+'" title="'+jsonObject.content.product.value[i].name+'">';
			 				htmlContentProduct = htmlContentProduct+'<img class="mobile-only rfk-img-responsive" src="'+imagePresetSrcMobile+'" title="'+jsonObject.content.product.value[i].name+'">';
			 				htmlContentProduct = htmlContentProduct+'</div>';

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12 col-8-sm text-left product-name" >';
			 				var brandName = jsonObject.content.product.value[i].brands[0];
			 				if(typeof(brandName) != 'undefined' && jsonObject.content.product.value[i].name.indexOf(brandName) ==0){
			 					htmlContentProduct = htmlContentProduct+"<strong>"+brandName+"</strong>";
			 					htmlContentProduct = htmlContentProduct+jsonObject.content.product.value[i].name.replace(brandName,"");
			 				}else{
			 					htmlContentProduct = htmlContentProduct+jsonObject.content.product.value[i].name;
			 				}

			 							 				htmlContentProduct = htmlContentProduct+'</div>';

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-8-sm mobile-only product-pricing rfk-product-pricing-mobile" >';
			 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">'+jsonObject.content.product.value[i].price_USD+'</span>';
			 				if(typeof(jsonObject.content.product.value[i].listprice_USD) != 'undefined' && 
			 						(jsonObject.content.product.value[i].listprice_USD.replace("$","")*1) > jsonObject.content.product.value[i].final_price){

			 								 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was'+jsonObject.content.product.value[i].listprice_USD+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</div>';			 				

			 							 				htmlContentProduct = htmlContentProduct+'<div class="col-12  text-center desktop-only product-pricing" >';
			 				htmlContentProduct = htmlContentProduct+'<span class="product-price-promo">'+jsonObject.content.product.value[i].price_USD+'</span>';

			 				if(typeof(jsonObject.content.product.value[i].listprice_USD) != 'undefined' && 
			 						(jsonObject.content.product.value[i].listprice_USD.replace("$","")*1) > jsonObject.content.product.value[i].final_price){
			 					htmlContentProduct = htmlContentProduct+'<span class="product-price-crossout"> was'+jsonObject.content.product.value[i].listprice_USD+'</span>';
			 				}
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 				htmlContentProduct = htmlContentProduct+'</div>';
			 			}
		}
			 			htmlContentProduct = htmlContentProduct+"</div>";
			 			htmlContentProduct =  htmlContentProduct+"<div class='row desktop-only'>";
			 			if(searchTerm == ""){

							}else{
								htmlContentProduct = htmlContentProduct+'<div class="col-2">&nbsp;</div><div class="col-8 text-center"><a href="javascript:document.CatalogSearchForm.submit()" class="btn btn-primary margin-bottom-sm btn-full" role="button">'+RFLK_SEE_ALL+'</a></div><div class="col-2"></div></div>';	
							}

			 									}else{
							if(searchTerm != ""){
			 				$("#productSuggestionResults_div").html("");
			 				$("#productSuggestionResults_div").hide();
			 				$("#productSuggestionResults_div").removeClass("show");
							}
			 			}
			 			if(isDataExistrs){
			 				$("#productSuggestionResults_div").show();
			 				$("#productSuggestionResults_div").addClass("show");
			 				$("#productSuggestionResults_div").html(htmlContentProduct);
			 				$("#look-ahead").addClass("active");
			 			}
						$("#reflektion_AutoCompleteList").addClass("show");
						$("#reflektion_AutoCompleteList").removeClass("hide");
						$("#reflektion_AutoCompleteList_empty").addClass("hide");
						$("#reflektion_AutoCompleteList_empty").removeClass("show");

			 						 			var isMobile = window.matchMedia("(max-width: 768px)").matches;
			 			if(!isMobile){
			 				setTimeout(function(){$(".prod-tile-rfl .product-name").dotdotdot();},25);
			 			}



			 						 										 			 var widthOfWindows = $(window).width()*0.50;
			 			if(($("#SimpleSearchForm_SearchTerm").width()*2) < widthOfWindows){
			 				widthOfWindows = $("#SimpleSearchForm_SearchTerm").width()*2;
			 			}
			 		    var heightOfWIndows = window.innerHeight-$("#header").height();
			 		   if($("#search.search.persist-active.active").length >0){
			 			  heightOfWIndows = heightOfWIndows - $("#search.search.persist-active.active").height();
			 		   }
			 			if(!isMobile){
			 				if($("#productSuggestionResults_div").height() > $("#infoPart").height()){
			 					$("#infoPart").height($("#productSuggestionResults_div").height());
			 				}else{
			 					$("#productSuggestionResults_div").height($("#infoPart").height());
			 				}
			 				if(($("#infoPart").height()+5) < heightOfWIndows){
			 					heightOfWIndows= $("#infoPart").height()+5;
			 				}
			 			    $("#look-ahead").width(widthOfWindows);
			 			    $("#look-ahead").height(heightOfWIndows);
			 			    $("#look-ahead").css("maxHeight",heightOfWIndows+"px");
			 				if($("#search.search.persist-active.active").length >0){
				 				$("#look-ahead").css("marginLeft","-"+($("#look-ahead").width()-($("#search.search.persist-active.active").width()))+"px");

				 								 			}else{
				 				$("#look-ahead").css("marginLeft","0px");
				 			}
			 			}else{

			 				 			 				 $("#look-ahead").width($(window).width());
				 			    $("#look-ahead").height((window.innerHeight-($("#header").height()+$("#search").height()))/2);
				 			   $("#look-ahead").css("maxHeight",(window.innerHeight-($("#header").height()+$("#search").height()))/2+"px");
			 			}
						if(lowerCaseSearchTerm == ""){
							$("#reflektion_autocomplete_brand").html($("#reflektion_autocomplete_brand_emptybox").html());
							$("#reflektion_autocomplete_searchterm").html($("#reflektion_autocomplete_searchterm_emptybox").html());
						}else{

														if(!$("#reflektion_autocomplete_category").hasClass("show")
									&& !$("#reflektion_autocomplete_brand").hasClass("show")
									&& !$("#reflektion_autocomplete_searchterm").hasClass("show")
									&& !$("#productSuggestionResults_div").hasClass("show")
									&& searchTerm != ""){
								$("#reflektion_AutoCompleteList_empty").addClass("show");
								$("#reflektion_AutoCompleteList_empty").removeClass("hide");
								$("#reflektion_AutoCompleteList").addClass("hide");
								$("#reflektion_AutoCompleteList").removeClass("show");

																if(!isMobile){
								$("#reflektion_AutoCompleteList_empty div.row div.col-12.emptyresult").html("<strong>No results for \""+searchTerm+"\"</strong>")
								}else{
									$("#reflektion_AutoCompleteList_empty div.row div.col-12.emptyresult").html("<strong>No results for \""+searchTerm.substring(0,150)+"\"</strong>")
								}
								$("#look-ahead").height($("#reflektion_AutoCompleteList_empty").height()*1.20);
							}
						}
		}

		function clear_Reflektion_autocomplete(){

					}
		function autoComplete_removeCommaBeforeSubmit(){
			var searchTerm = $("#SimpleSearchForm_SearchTerm");
			var searchButton = $('#submitButton');	
			if(searchTerm.val().length > 0 ){
				searchButton.addClass('active');
				var searchTermVal = searchTerm.val();
				searchTerm.val(searchTermVal.split("’").join("'"));
				if(searchTermVal.indexOf(",")>-1 && searchTermVal.split(",").length > 2 ){
					searchTermVal = searchTermVal.replace(",","<<COMMA>>");
					searchTermVal = searchTermVal.replace(",","<<COMMA>>");
					searchTermVal = searchTermVal.split(",").join("");
					searchTermVal = searchTermVal.split("<<COMMA>>").join(",");
					searchTerm.val(searchTermVal);
				}
			}else {
				searchButton.removeClass('active');
			}
		}function reflektion_init(){
			setUserContextFromLocalStorage();
			accessTokenFromLocalStorage();
			formAutoCompleteRequests();
			formRfkRecommendationRequest();			
		}

				function formAutoCompleteRequests(){
			var uuid="RFK_UUID",
			user_id="-1002",
			widgetAutoComplete="";
			if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) != 'undefined' && typeof(rfk.uid) == 'function'){
				uuid = rfk.uid();
			}
			var user_id_cookie = getCookie('WC_UserId');
			if(typeof(user_id_cookie)!= 'undefined'){
				user_id=user_id_cookie;
			}
			if($("#REFLEKTION_RFKID_AUTOCOMPLETE").length > 0){
				widgetAutoComplete = $("#REFLEKTION_RFKID_AUTOCOMPLETE").val();
			}
			reflectionAutoCompleteRequests = {};
			reflectionAutoCompleteRequests.data = {};
			reflectionAutoCompleteRequests.data.context = {};
			reflectionAutoCompleteRequests.data.context.page = {};
			reflectionAutoCompleteRequests.data.context.page.uri = "/full_search_page";
			reflectionAutoCompleteRequests.data.context.user = {};
			reflectionAutoCompleteRequests.data.context.user.uuid = uuid;
			reflectionAutoCompleteRequests.data.context.user.user_id = user_id;
			reflectionAutoCompleteRequests.data.widget = {};
			reflectionAutoCompleteRequests.data.widget.rfkid = widgetAutoComplete;
			var noOfProductsToBefetched = 6;
			if($("#noofproducts").length > 0){
				noOfProductsToBefetched = $("#noofproducts").val()*1;
			}
			reflectionAutoCompleteRequests.data.n_item = noOfProductsToBefetched;
			reflectionAutoCompleteRequests.data.page_number = 1;
			reflectionAutoCompleteRequests.data.query = {};
			reflectionAutoCompleteRequests.data.query.keyphrase = {};
			reflectionAutoCompleteRequests.data.query.keyphrase.value = [];
			reflectionAutoCompleteRequests.data.suggestion = {};
			reflectionAutoCompleteRequests.data.suggestion.brand = {};
			reflectionAutoCompleteRequests.data.suggestion.brand.max = 3;
			reflectionAutoCompleteRequests.data.suggestion.keyphrase = {};
			reflectionAutoCompleteRequests.data.suggestion.keyphrase.max = 2;
			reflectionAutoCompleteRequests.data.suggestion.category = {};
			reflectionAutoCompleteRequests.data.suggestion.category.max = 4;
			reflectionAutoCompleteRequests.data.suggestion.trending_category = {};
			reflectionAutoCompleteRequests.data.suggestion.trending_category.max = 4;
			reflectionAutoCompleteRequests.data.content={};
			reflectionAutoCompleteRequests.data.content.product={};
			reflectionAutoCompleteRequests.data.content.product.field={};
			reflectionAutoCompleteRequests.data.content.product.field.value=[];
			reflectionAutoCompleteRequests.data.content.product.field.value.push("sku");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("price");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("final_price");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("category_names");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("name");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("url");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("image_url");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("prod_partnumber");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("listprice_USD");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("bopusprice_USD");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("price_USD");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("name");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("price");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("rd_price_USD");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("sku_partnumber");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("brands");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("ptc_omni_repeat_delivery_fl");
			reflectionAutoCompleteRequests.data.content.product.field.value.push("swatch");

			 		}
		function generateReflektionAutoCompleteUrl(url,reflektionEnabed){
			var urlReturn=getAbsoluteURL()+url;
			if(reflektionEnabed){
				var rFKHeader=getCookie("RFKHeader");
				if(typeof(rFKHeader) != "undefined" && rFKHeader != null && rFKHeader == 'rfk' ){
					$("#ENABLE_REFLEKTION").val("true");
					urlReturn = urlReturn+"&reflektionEnabled=true"
				}else{
					setCookie("RFKHeader", 'rfk');
					$("#ENABLE_REFLEKTION").val("true");
					urlReturn = urlReturn+"&reflektionEnabled=true"
				}

							}else{
				$("#ENABLE_REFLEKTION").val("false");
				urlReturn = urlReturn+"&reflektionEnabled=false"
			}
			return urlReturn;
		}
		function setUserContextFromLocalStorage() {				
			var oStores = JSON.parse(localStorage.getItem('petcostores'));
			if(oStores != undefined && oStores != null && Object.keys(oStores).length > 0 ){
				var oPetcostores = oStores.petcostores;
				if(typeof(oPetcostores) != "undefined"){
					var storeVal = JSON.parse(oPetcostores);				
					if(storeVal.length > 1){
					 	for(var i=0;i<storeVal.length;i++){ 
					 		if( typeof(storeVal[i].isPreferred)== "undefined" || storeVal[i].isPreferred != "Y"){
					 			USER_CONTEXT.zipCode = storeVal[i].ZIPCODE;
					 			USER_CONTEXT.state = storeVal[i].STATE;
					 			USER_CONTEXT.country = 'US';	
					 			break;
							}
					 	}				 	
					}
				}			
			}
		}
		function setRfkRecommendationSKU(skuPartNumber){
			RECOMMENDATION_PDP_SKU = skuPartNumber;
		}
		function rfkRecommendation_init(rfkWidgetId){
			if(enableRfkRecommendation()) {
				var recommendationCall = setInterval(function(){ 				
					if(IS_KEY_RETRIVED){
						rfkPopulateRecommendation(rfkWidgetId);

											clearInterval(recommendationCall);
					}
				}, 100);
			}


							}
		function formRfkRecommendationRequest(){
			var uuid="RFK_UUID",
			user_id="-1002";

						if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) != 'undefined' && typeof(rfk.uid) == 'function' ){
				uuid = rfk.uid();
			}
			var user_id_cookie = getCookie('WC_UserId');
			if(typeof(user_id_cookie)!= 'undefined'){
				user_id=user_id_cookie;
			}

						rfkRecommendationRequest = {};
			rfkRecommendationRequest.data = {};
			rfkRecommendationRequest.data.n_item = {};	
			rfkRecommendationRequest.data.batch = [];
			rfkRecommendationRequest.data.appearance = {};
			rfkRecommendationRequest.data.appearance.templates = {};
			rfkRecommendationRequest.data.appearance.variables = {};
			rfkRecommendationRequest.data.context = {};
			if(Object.keys(USER_CONTEXT).length > 0) {
				rfkRecommendationRequest.data.context.geo = {};
				rfkRecommendationRequest.data.context.geo.country = USER_CONTEXT.country;
				rfkRecommendationRequest.data.context.geo.state = USER_CONTEXT.state;
				rfkRecommendationRequest.data.context.geo.zip = USER_CONTEXT.zipCode;
			}
			rfkRecommendationRequest.data.context.page = {};
			rfkRecommendationRequest.data.context.page.uri = document.location.href;
			rfkRecommendationRequest.data.context.page.sku = {};
			rfkRecommendationRequest.data.context.user = {};
			rfkRecommendationRequest.data.context.user.uuid = uuid;
			rfkRecommendationRequest.data.context.user.user_id = user_id;	
			rfkRecommendationRequest.data.query = {};
			rfkRecommendationRequest.data.query.keyphrase = {};
			rfkRecommendationRequest.data.query.keyphrase.value = [];
			rfkRecommendationRequest.data.content = {};
			rfkRecommendationRequest.data.content.product = {};	
			rfkRecommendationRequest.data.content.product.field={};
			rfkRecommendationRequest.data.content.product.field.value=[];
			rfkRecommendationRequest.data.content.product.field.value.push("sku");
			rfkRecommendationRequest.data.content.product.field.value.push("price");
			rfkRecommendationRequest.data.content.product.field.value.push("final_price");
			rfkRecommendationRequest.data.content.product.field.value.push("category_names");
			rfkRecommendationRequest.data.content.product.field.value.push("name");
			rfkRecommendationRequest.data.content.product.field.value.push("brand");
			rfkRecommendationRequest.data.content.product.field.value.push("url");
			rfkRecommendationRequest.data.content.product.field.value.push("image_url");
			rfkRecommendationRequest.data.content.product.field.value.push("prod_partnumber");
			rfkRecommendationRequest.data.content.product.field.value.push("listprice_USD");
			rfkRecommendationRequest.data.content.product.field.value.push("bopusprice_USD");
			rfkRecommendationRequest.data.content.product.field.value.push("price_USD");
			rfkRecommendationRequest.data.content.product.field.value.push("name");
			rfkRecommendationRequest.data.content.product.field.value.push("price");
			rfkRecommendationRequest.data.content.product.field.value.push("rd_price_USD");
			rfkRecommendationRequest.data.content.product.field.value.push("sku_partnumber");
			rfkRecommendationRequest.data.content.product.field.value.push("swatch");
			rfkRecommendationRequest.data.content.product.field.value.push("ptc_omni_repeat_delivery_fl");
			rfkRecommendationRequest.data.content.product.field.value.push("review_rating");
			rfkRecommendationRequest.data.content.product.field.value.push("review_count");
			rfkRecommendationRequest.data.content.product.field.value.push("ptc_omni_personalized_item_fl");	
			rfkRecommendationRequest.data.content.product.field.value.push("ptc_omni_rx_food_ind");
			rfkRecommendationRequest.data.content.product.field.value.push("ptc_omni_pdp_behavior_template");	
			rfkRecommendationRequest.data.content.product.field.value.push("ptc_omni_in_store_only_flag");
		}

				function rfkPopulateRecommendation(rfkWidgetId){
			var URL = "//"+REFLEKTION_API_URL_HOST;
			var rfkRecommendationWidget="";
			var rfkRecommendationTitleWidget="";
			var rfkwidgetControlParam = "";
			var rfkNoOfProducts = 5;
			var rfkSkus = [];
			var rfkCategories = [];
			var rfkSearchTerm;
			var sendRecommendationRequest = true;
			var widgetControlParamVar;
			var rfkWidgetNameVar;
			var rfkTitleWidgetNameVar;
			var rfkNoOfProductsVar;

						widgetControlParamVar = "#" + rfkWidgetId + "-" + "rfkwidgetControlParam";
			rfkWidgetNameVar = "#" + rfkWidgetId + "-" + "rfkWidgetName";
			rfkTitleWidgetNameVar = "#" + rfkWidgetId + "-" + "rfkTitleWidgetName";
			rfkNoOfProductsVar = "#" + rfkWidgetId + "-" + "rfkNoOfProducts";

						if($(widgetControlParamVar).length > 0){
				rfkwidgetControlParam = $(widgetControlParamVar).val();				
			}
			if($(rfkWidgetNameVar).length > 0){
				rfkRecommendationWidget = $(rfkWidgetNameVar).val();
			}
			if($(rfkTitleWidgetNameVar).length > 0){
				rfkRecommendationTitleWidget = $(rfkTitleWidgetNameVar).val();
			}
			if($(rfkNoOfProductsVar).length > 0){
				rfkNoOfProducts = parseInt($(rfkNoOfProductsVar).val());
			}
			if(rfkwidgetControlParam == 'UID') {

						} else if(rfkwidgetControlParam == 'PDP') {
				rfkSkus = RECOMMENDATION_PDP_SKU;
				rfkRecommendationRequest.data.context.page.sku = [];				
				rfkRecommendationRequest.data.context.page.sku.push(rfkSkus);
				if(RFKIDMAP[rfkRecommendationWidget] == rfkSkus){
					sendRecommendationRequest =false;
				}
				RFKIDMAP[rfkRecommendationWidget] = rfkSkus;
			} else if((rfkwidgetControlParam == 'CART') || (rfkwidgetControlParam == 'OCP')||(rfkwidgetControlParam == 'PDP_ATC_MODAL') ||(rfkwidgetControlParam == 'RD_DETAILS_PAGE')) {
				if($("#rfkRecommendationPartNumber").length > 0){
					rfkSkus = $("#rfkRecommendationPartNumber").val().split(',');
				}
				rfkRecommendationRequest.data.context.page.sku = [];				
				rfkRecommendationRequest.data.context.page.sku = rfkSkus;
			} else if(rfkwidgetControlParam == 'PLP') {
				if($("#rfkRecommendationCategories").length > 0){
					rfkCategories = $("#rfkRecommendationCategories").val().split(',');
				}				
				rfkRecommendationRequest.data.context.page.all_category_ids = [];	
				rfkRecommendationRequest.data.context.page.all_category_ids = rfkCategories;
			} else if(rfkwidgetControlParam == 'SRCHPLP') {
				if($("#rfkSearchTerm").length > 0){
					rfkSearchTerm = $("#rfkSearchTerm").val();
				}				
				rfkRecommendationRequest.data.query.keyphrase.value = [];				
				if(rfkSearchTerm != ""){
					rfkRecommendationRequest.data.query.keyphrase.value.push(rfkSearchTerm);
				} else {
					sendRecommendationRequest = false;
				}				
			}			
			rfkRecommendationRequest.data.n_item = rfkNoOfProducts;
			 rfkRecommendationRequest.data.batch = [];

			 			 var rfkRecommendationWidgetVal = {};
			 rfkRecommendationWidgetVal.widget = {};
			 rfkRecommendationWidgetVal.widget.rfkid = rfkRecommendationWidget;
			 rfkRecommendationRequest.data.batch.push(rfkRecommendationWidgetVal);
			if(rfkRecommendationTitleWidget.trim() != ""){
				rfkRecommendationWidgetVal = {};
				 rfkRecommendationWidgetVal.widget = {};
				 rfkRecommendationWidgetVal.widget.rfkid = rfkRecommendationTitleWidget.trim();
				 rfkRecommendationRequest.data.batch.push(rfkRecommendationWidgetVal);				
			}
            var uuid="RFK_UUID";
        	if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) != 'undefined' && typeof(rfk.uid) == 'function'){
        		uuid = rfk.uid();
        	}

        	        	rfkRecommendationRequest.data.context.user.uuid = uuid;
			if(sendRecommendationRequest) {
				$.ajax({
					url : URL,
					type: 'POST',
					data: JSON.stringify(rfkRecommendationRequest),
					headers: {"Authorization": "Bearer "+REFLEKTION_ACCESS_TOKEN},
					beforeSend : function(xhr){ 
						xhr.setRequestHeader('Content-Type', 'application/json');     
					}, 
					success : function(dataVal) {
						if(typeof(dataVal) != 'undefined' ){
							loadRfkRecommendationWidgets(dataVal, rfkWidgetId,rfkRecommendationWidget,rfkRecommendationTitleWidget.trim());
							ReflektionHelperJS.bopusAreaRestrictionCheck();
						} else {
							console.log("invalid response from RFK");
						}
					},
					dataType : 'json',
					timeout : REFLEKTION_API_TIMEOUT,
					error : function(jqXHR, errorType, exception) { 
						logErrorFromReflektion(jqXHR, errorType, exception);
						resetRecommendation();       
					},
					complete: function(dataVal,textStatus ){
						triggerWidgetCall(rfkWidgetId,dataVal,textStatus,rfkRecommendationWidget,rfkRecommendationTitleWidget.trim());
					},
				});
			}


								}
		function triggerWidgetCall(rfkWidgetId,dataVal,textStatus,rfkRecommendationWidget,titleWidgetName ){
			try{
				widgetsFiredForRecommetnaions.push(rfkWidgetId);
				var isAllWidgetCompleted = true;
				$("div[rfk_widget_id]").each(function(i,obj){
					if(!widgetsFiredForRecommetnaions.includes($(obj).attr("rfk_widget_id"))){
						isAllWidgetCompleted = false;
					}

									})
				if(textStatus === 'success'){
					var responseJSON  = dataVal.responseJSON;
					var jsonObject;
					if(titleWidgetName == ""){
						jsonObject = responseJSON;
					}else{
						for(var i in responseJSON.batch){
							var widgetId = responseJSON.batch[i].widget.rfkid;
							if(widgetId == rfkRecommendationWidget ){
								jsonObject = responseJSON.batch[i];
							}						
						}
					}


															if(jsonObject){
						var content  = jsonObject.content;
						if(typeof(jsonObject.content) != 'undefined' && typeof(jsonObject.content.product) != 'undefined' && typeof(jsonObject.content.product.value) != 'undefined'){
							var productList = jsonObject.content.product.value;
							for( var inst in productList){
								for(var swatchid in productList[inst].swatch){
									var productIdForSwatch =  productList[inst].swatch[swatchid].sku_uid;
									if(!productIdToFetchPrice.includes(productIdForSwatch)){
										productIdToFetchPrice.push(productIdForSwatch);
									}
								}
							}
						}
					}
				}

					if(isAllWidgetCompleted && Object.getOwnPropertyNames(solrProductPriceMap).length > 0){
					isAllWidgetCompleted = false;					
					for(var ids in productIdToFetchPrice){						
						if(typeof(solrProductPriceMap[productIdToFetchPrice[ids]]) === 'undefined'){
							isAllWidgetCompleted = true;
							break;
						}
					}
					if(!isAllWidgetCompleted){
						updateSolrPrice();
					}

									}




																if(isAllWidgetCompleted && !isCallInitialtedForSOlr){
					var fetchPrceChange = {};
					var paramFetchPrice = "productIds="+ productIdToFetchPrice.toString();
					$.ajax({
						url : getAbsoluteURL()+"PetcoFetchPriceFromSolr",
						type: 'POST',
						data: paramFetchPrice,
						beforeSend : function(xhr){ 
							isCallInitialtedForSOlr = true;
						}, 
						success : function(dataVal) {
								for( var priceData in dataVal){
									var producTidval = dataVal[priceData].productId;
									var listprice_USD = dataVal[priceData].listprice_USD;
									var price_USD = dataVal[priceData].price_USD;
									var rd_price_USD = 	dataVal[priceData].rd_price_USD;

																		var priceMapDetails = {};
									priceMapDetails["listprice_USD"] = listprice_USD;
									priceMapDetails["price_USD"] = price_USD;
									priceMapDetails["rd_price_USD"] = rd_price_USD;
									solrProductPriceMap[producTidval]= priceMapDetails;

																		}
								updateSolrPrice();
						},
						complete: function(){
							isCallInitialtedForSOlr = false;
						},
						dataType : 'json',
						timeout : 5000
					});

									}
			}catch (error) {
				console.log(error)
			}
		}

				function triggerWidgetCallInBatch(dataVal, textStatus, recommendationDataForRfkCall){

									try{

								if(textStatus === 'success'){

										var rfkResponseForRecommendationCall  = dataVal.responseJSON;
					var productIdToFetchPriceInBatch = [];
					var isPriceFromSolrCallNeeded = false;

										$.each( recommendationDataForRfkCall.widgetArr , function( index, recommendationWidget ){

												var jsonObject={};				
						var rfkRecWidgetName = recommendationWidget.rfkWidgetName;

												for(var i in rfkResponseForRecommendationCall.batch){					
								var widgetId = rfkResponseForRecommendationCall.batch[i].widget.rfkid;
								if(widgetId == rfkRecWidgetName ){
										jsonObject = rfkResponseForRecommendationCall.batch[i];
										break;
								}					
						}

												if(jsonObject){
							var content  = jsonObject.content;
							if(typeof(jsonObject.content) != 'undefined' && typeof(jsonObject.content.product) != 'undefined' && typeof(jsonObject.content.product.value) != 'undefined'){
								var productList = jsonObject.content.product.value;
								for( var inst in productList){
									for(var swatchid in productList[inst].swatch){
										var productIdForSwatch =  productList[inst].swatch[swatchid].sku_uid;
										if(!productIdToFetchPriceInBatch.includes(productIdForSwatch)){
											productIdToFetchPriceInBatch.push(productIdForSwatch);
										}
									}
								}
							}
						}

												if(Object.getOwnPropertyNames(solrProductPriceMap).length > 0){
								for(var ids in productIdToFetchPriceInBatch){		
										if(typeof(solrProductPriceMap[productIdToFetchPriceInBatch[ids]]) === 'undefined'){
												isPriceFromSolrCallNeeded = true;
												break;
										}
								}					
						}
						else{
							isPriceFromSolrCallNeeded = true;
						}
					});

										if(isPriceFromSolrCallNeeded && !isCallInitialtedForSOlr){

												var paramFetchPrice = "productIds="+ productIdToFetchPriceInBatch.toString();
						$.ajax({
							url : getAbsoluteURL()+"PetcoFetchPriceFromSolr",
							type: 'POST',
							data: paramFetchPrice,
							beforeSend : function(xhr){ 
								isCallInitialtedForSOlr = true;
							}, 
							success : function(dataVal) {
									for( var priceData in dataVal){
										var producTidval = dataVal[priceData].productId;
										var listprice_USD = dataVal[priceData].listprice_USD;
										var price_USD = dataVal[priceData].price_USD;
										var rd_price_USD = 	dataVal[priceData].rd_price_USD;

																				var priceMapDetails = {};
										priceMapDetails["listprice_USD"] = listprice_USD;
										priceMapDetails["price_USD"] = price_USD;
										priceMapDetails["rd_price_USD"] = rd_price_USD;
										solrProductPriceMap[producTidval]= priceMapDetails;											
									}
									updateSolrPrice();
							},
							complete: function(){
								isCallInitialtedForSOlr = false;
							},
							dataType : 'json',
							timeout : 5000
						});
					}
					else{
						updateSolrPrice();
					}					
				}

							} catch (error) {
				console.log(error)
			}

					}

				function updateSolrPrice(){
			try{
				var itemIdsList = $('input[id$="productId-tagging"]');
				if(typeof(solrProductPriceMap) === 'undefined'){
					return;
				}
				$(itemIdsList).each(function(i,obj){
					if(obj.value != ""){
						var idPrefeix = obj.id.replace("-productId-tagging","");
						var productId = obj.value;
						var productObject = solrProductPriceMap[productId];
						if(typeof(productObject) != 'undefined'){
							var priceUSD = productObject["price_USD"];
							var listpriceUSD = productObject["listprice_USD"];
							var rdPriceUSD = productObject["rd_price_USD"];
							if(priceUSD != ""){
								var rfkwidgetControlParam = "";
								var rfkwidgetId = $("#rfkWidgetId").val();
								var widgetControlParamVar = "#" + rfkwidgetId + "-" + "rfkwidgetControlParam";
							   	if($(widgetControlParamVar).length > 0){
									rfkwidgetControlParam = $(widgetControlParamVar).val();				
								}
						   		var offerPriceVar = "#"+idPrefeix + "-price-promo";
								if($(offerPriceVar).length > 0){
									if(rfkwidgetControlParam == 'RD_DETAILS_PAGE' && rdPriceUSD != ""){
										$(offerPriceVar).html(rdPriceUSD);
								   	}
									else{
										$(offerPriceVar).html(priceUSD);
									}
								}
												var rfkProductListPriceTaggingElement = "#"+  idPrefeix + "-productListPrice-tagging";												
												if ($(rfkProductListPriceTaggingElement)&& listpriceUSD != "" ) {
													$(rfkProductListPriceTaggingElement).val(listpriceUSD);
												}

																				if(rfkwidgetControlParam != 'RD_DETAILS_PAGE'){
									var listPriceVar = "#"+idPrefeix + "-price-crossout";
									if(typeof(listpriceUSD) != 'undefined' && listpriceUSD != "" && 
												((listpriceUSD.replace("$","")*1) > priceUSD.replace("$","")*1)){
										if($(listPriceVar).length > 0){
											$(listPriceVar).html('was ' + listpriceUSD);
										}					
									}else{
										if($(listPriceVar).length > 0){
											$(listPriceVar).html("");
										}		
									}
									var rdPriceDiv = "#"+idPrefeix + "-price-rd-val";
									if($(rdPriceDiv).length > 0 && rdPriceUSD != ""){					
										$(rdPriceDiv).html(rdPriceUSD);
									}else if($(rdPriceDiv).length > 0 && rdPriceUSD == ""){
										$(rdPriceDiv).html("");
									}										
								}
							}
						}

										}
				});
				if (null != $('#adobeDataLayerEnabled')
						&& undefined != $('#adobeDataLayerEnabled')
						&& $('#adobeDataLayerEnabled').val() == 'true') {
					var testWidgetControlParam = "";
					var testWidgetId = $("#rfkWidgetId").val();
					var testWidgetControlParamVar = "#" + testWidgetId + "-" + "rfkwidgetControlParam";
					if($(testWidgetControlParamVar).length > 0){
					testWidgetControlParam = $(testWidgetControlParamVar).val();
					}
					if(testWidgetControlParam == 'RD_DETAILS_PAGE'){
						var adobeDataLayerRfkRecommendationTriggeredArr = [];
						if ("IntersectionObserver" in window){
							var n = new IntersectionObserver(function (e, t) {
								e.forEach(function (e) {
									if (e.isIntersecting) {
										if(!adobeDataLayerRfkRecommendationTriggeredArr.includes(e.target.id)){
											adobeDataLayerRfkRecommendationTriggeredArr.push(e.target.id);
											adobeBuildReflektionWidget(e.target.id);
										}
									}
								});
							});

									const rfkrecomendationList = document.querySelectorAll(".rfk_recommendation_wrapper");
							var rfkIndex = 0;
							rfkrecomendationList.forEach(function (rfkrecomendation){
								n.observe(rfkrecomendation);
								if(null!= rfkrecomendationList[rfkIndex].id && undefined != rfkrecomendationList[rfkIndex].id){
									var modulePosRfkId = rfkrecomendationList[rfkIndex].id.split("_").pop();
									var rfkModulePosTaggingElement =  modulePosRfkId +  "-rfkModulePosition";
									rfkIndex++;
									if (document.getElementById(rfkModulePosTaggingElement) ){ 
										document.getElementById(rfkModulePosTaggingElement).value = rfkIndex;
										}
								}
								});
							}
					}
				}				
			}catch (error) {
				console.log(error)
			}

					}

				function logErrorFromReflektion(jqXHR, errorType, exception){
			if(errorType == 'timeout'){
				console.log("Reflektion API request timed out");
			} else {
				var responseText = jQuery.parseJSON(jqXHR.responseText);
				console.log("Reflektion error code:" + responseText.err);
				console.log("Reflektion error message:" + responseText.msg);
			}			
		}

				function boldString(productName, brand){
			var regex = new RegExp(brand, 'ig');
			return productName.replace(regex, '<strong>'+brand+'</strong>');
		}		

				function loadRfkRecommendationWidgets(jsonObjectMain, rfkWidgetId, mainWidgetName, titleWidgetName){
			if(recommendationParsedSkuDetails[rfkWidgetId] != undefined) {
				delete recommendationParsedSkuDetails[rfkWidgetId];				
			}
			var jsonObject={};
			var jsonObjectTitle={};
			if(titleWidgetName == ""){
				jsonObject = jsonObjectMain;
			}else{
				for(var i in jsonObjectMain.batch){					
					var widgetId = jsonObjectMain.batch[i].widget.rfkid;
					if(widgetId == mainWidgetName ){
						jsonObject = jsonObjectMain.batch[i];
					}else if(widgetId == titleWidgetName){
						jsonObjectTitle  = jsonObjectMain.batch[i];
					}
					var variationId = jsonObjectMain.batch[i].widget.variation_id;
					var experimentId = jsonObjectMain.batch[i].widget.experiment_id;
					var experimentBucket = jsonObjectMain.batch[i].widget.experiment_bucket;

										var rfkVariationIdTaggingElement =  rfkWidgetId +  "-rfkVariationId-tagging";
					if (document.getElementById(rfkVariationIdTaggingElement) && undefined != variationId) { document.getElementById(rfkVariationIdTaggingElement).value = variationId; }
					var rfkExperimentIdTaggingElement =  rfkWidgetId +  "-rfkExperimentId-tagging";
					if (document.getElementById(rfkExperimentIdTaggingElement) && undefined != experimentId) { document.getElementById(rfkExperimentIdTaggingElement).value = experimentId; }				
					var rfkExperimentBucketTaggingElement =  rfkWidgetId +  "-rfkExperimentBucket-tagging";
					if (document.getElementById(rfkExperimentBucketTaggingElement) && undefined != experimentBucket) { document.getElementById(rfkExperimentBucketTaggingElement).value = experimentBucket; }		

				}
			}

						if(typeof(jsonObject.content) == 'undefined' || typeof(jsonObject.content.product) == 'undefined'){
				return;
			}

						var elementIdPrefix = "#" + rfkWidgetId + "-";
			$('select[id^="'+rfkWidgetId+'-"]').remove();
			var widgetTitleVar = elementIdPrefix + 'widgetTitle';
			var carouselPrev = elementIdPrefix + 'prev';
			var carouselNext = elementIdPrefix + 'next';
			var rfkEnableSkuSelectionVar = elementIdPrefix + "rfkEnableSkuSelection";
			var rfkEnableSkuSelection;
			if($(rfkEnableSkuSelectionVar).length > 0){
				rfkEnableSkuSelection = $(rfkEnableSkuSelectionVar).val();
			}	
			if(typeof(jsonObjectTitle) != 'undefined' && typeof(jsonObjectTitle.appearance) != 'undefined'
				&& typeof(jsonObjectTitle.appearance.variables) != 'undefined' && typeof(jsonObjectTitle.appearance.variables.title) != 'undefined'){
				var classes = jsonObjectTitle.appearance.css_names;
				$(classes).each(function(i,obj){
					$(widgetTitleVar).addClass(obj);
				})
				var variables = jsonObjectTitle.appearance.variables;
				var text_color = variables["text-color"].value;
				if(text_color != ""){
					$(widgetTitleVar).css( "color", text_color);
				}

								var title = variables.title.value;
				if(title != ""){
					$(widgetTitleVar).html(title);
				}
			}


									var recommendedSkuCount =  parseInt(jsonObject.n_item);
			if(recommendedSkuCount > 0) {
				$(widgetTitleVar).show();			
				var definingAttributesCount = 0;
				for(var productIndex in jsonObject.content.product.value){
					elementIndex = parseInt(productIndex) + 1;				
					prodMainDiv = elementIdPrefix + elementIndex;
					$(prodMainDiv).show();	
					parseProductDetails(jsonObject.content.product.value[productIndex], rfkWidgetId, rfkEnableSkuSelection);
					var productPartNumber = jsonObject.content.product.value[productIndex].prod_partnumber;
					var selectedSwatch = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].selected_swatch;
					renderProductDetails(rfkWidgetId, elementIndex, selectedSwatch, productPartNumber, false);	
				}

								showOrHideContainer(rfkWidgetId, true);

								if(recommendedSkuCount > 3) {
					if($(carouselPrev).length > 0) {
						$(carouselPrev).css({'display':'block'})
					}
					if($(carouselNext).length > 0) {
						$(carouselNext).css({'display':'block'})
					}					
				}

							} else {
			}
		}

				function showOrHideContainer(rfkWidgetId, showFlag) {
			var elementIdPrefix = rfkWidgetId + "-";
			var widgetParentContainerField =  '#'+rfkWidgetId+"-parent";			
			if($(widgetParentContainerField).length > 0) {
				var containerParent =  $(widgetParentContainerField).val();				
				var containerId;
				if(containerParent.length > 0) {
					containerId = '#container_rfk_recommendation_'+ containerParent;					
					if(showFlag == true) {
						$(containerId).show();
					} else {
						$(containerId).hide();
					}					
				}
			}		
		}


						function renderProductDetails(rfkWidgetId, elementIndex, selectedSwatch, productPartNumber, isRefreshWidget,isfromComboBox){
			var rfkwidgetControlParam = "";
			var widgetControlParamVar = "#" + rfkWidgetId + "-" + "rfkwidgetControlParam";
		   	if($(widgetControlParamVar).length > 0){
				rfkwidgetControlParam = $(widgetControlParamVar).val();				
			}
			var isfromComboBoxFlag = false;
			if(typeof(isfromComboBox) != 'undefined'){
				isfromComboBoxFlag = true;
			}
			var rfkEnableSkuSelection;
			var rfkEnableAddToCart;
			var productName = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].name;	
			var brand = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].brand;
			var selectedSkuPartNumber = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].primary_sku;
			var imgURL = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].image_url;
			var priceUSD = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].price_USD;
			var listpriceUSD =  recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].listprice_USD;
			var rdPriceUSD = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].rd_price_USD;
			var reviewRating = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].review_rating;
			var isRDEligible = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].rd_eligible;
			var definingAttributesCount = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].defining_attr_count;
			var pdpURL = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].url;
			var personalizedItemFlag = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].personalizedItemFlag;
			var rxFoodIndicator = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].rxFoodIndicator;
			var rxPharmaIndicator = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].rxPharmaIndicator;
			var inStoreOnlyIndicator = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].inStoreOnlyIndicator;
			var bopusIndicator;
			var is_bopus_area_restriction_req = "";
			var elementIdPrefix = "#" + rfkWidgetId + "-";			
			var clsLoadingelementIdPrefix = "#clsLoading-" + rfkWidgetId + "-";
			var rfkEnableSkuSelectionVar = elementIdPrefix + "rfkEnableSkuSelection";
			var rfkEnableAddToCartVar = elementIdPrefix + "rfkEnableAddToCart";			
			if($(rfkEnableSkuSelectionVar).length > 0){
				rfkEnableSkuSelection = $(rfkEnableSkuSelectionVar).val();
			}			
			if($(rfkEnableAddToCartVar).length > 0){
				rfkEnableAddToCart = $(rfkEnableAddToCartVar).val();
			}

						if(isRefreshWidget == false) {
				var prodMainDiv = elementIdPrefix + elementIndex;	
				var clsLoadingprodMainDiv = clsLoadingelementIdPrefix +elementIndex;
				var prodNameVar = elementIdPrefix + elementIndex + "-name-link";

							$(prodMainDiv).show();
				$(clsLoadingprodMainDiv).hide();
				if($(prodNameVar).length > 0){
					$(prodNameVar).click(function() {
						location.href = pdpURL;
					});					
					if(brand != undefined && brand != "") {
						formattedName = boldString(productName, brand);							
					} else {
						formattedName = productName;
					}						
					$(prodNameVar).html(formattedName);
					if($(prodNameVar).css("overflow-wrap") != "break-word"){
						$(prodNameVar).dotdotdot();
					}
				}	
				showReviewRating(rfkWidgetId, elementIndex, productPartNumber);				
				if(rfkEnableSkuSelection == 'yes'){		
						populateAttribute(rfkWidgetId, productPartNumber, elementIndex,definingAttributesCount);	
				}			
			}

									if(Object.keys(selectedSwatch).length > 0) {
				selectedSkuPartNumber = selectedSwatch.sku_partnumber;
				imgURL = selectedSwatch.image_url;	


												priceUSD = selectedSwatch.price_USD;

								listpriceUSD =  selectedSwatch.listprice_USD;
				isRDEligible = selectedSwatch.ptc_omni_repeat_delivery_fl;
				rdPriceUSD = selectedSwatch.rd_price_USD;	
				bopusIndicator = selectedSwatch.ptc_omni_bopus_flag;
				is_bopus_area_restriction_req = selectedSwatch.is_bopus_area_restriction_req;
			}
			var priceRDDIvTMP =  elementIdPrefix + elementIndex + "-price-rd";
			var priceDIvTMP =  elementIdPrefix + elementIndex + "-price";
			if(typeof(is_bopus_area_restriction_req) != 'undefined' && is_bopus_area_restriction_req != "" && is_bopus_area_restriction_req.toLowerCase() == 'yes'){
				$(priceRDDIvTMP+".product-pricing").addClass('hideBopusAreaRestriction');
				$(priceDIvTMP+".product-pricing").addClass('hideBopusAreaRestriction');
			}else{
				$(priceRDDIvTMP+".product-pricing").removeClass('hideBopusAreaRestriction');
				$(priceDIvTMP+".product-pricing").removeClass('hideBopusAreaRestriction');
			}
			var imageVar = elementIdPrefix + elementIndex + "-img";
			if($(imageVar).length > 0){
				if($(imageVar+".verticalImage_rfk").length > 0){

										var imagePresetSrc =  imgURL + '?$tile-recommendations$';
					if (isCloudniaryEnabled()) {
						imagePresetSrc = imgURL.replace('f_auto,q_auto', 'f_auto,q_auto,w_190');
					} 
					if(rfkwidgetControlParam == 'PDP_ATC_MODAL') {
						$(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="javascript:trackATCInterstitailClick(\'modal_prod_rec_click\'); return true;">' + '<img class="img-responsive"  src="'+ imagePresetSrc + '" title="' + productName + '">' + '</a>');	
					} else {
						$(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="clickTrackLink(this);adobeClickReflektionWidget(this);" adobe_manual_cm_sp="recommeded for you | reflektion product">' + '<img class="img-responsive"  src="'+ imagePresetSrc + '" title="' + productName + '">' + '</a>');					  
					}					
				}else{
					var imagePresetSrc =  imgURL + '?$PLP-item-large$';
					if (isCloudniaryEnabled()) {
						imagePresetSrc = imgURL.replace('f_auto,q_auto', 'f_auto,q_auto,t_PLP-item-large');
					} 
					if(rfkwidgetControlParam == 'PDP_ATC_MODAL') {
						$(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="javascript:trackATCInterstitailClick(\'modal_prod_rec_click\');return true;">' + '<img src="'+ imagePresetSrc + '" title="' + productName + '">' + '</a>');
					} else {
						$(imageVar).html('<a href="'+ pdpURL +'" target="_parent" onclick="clickTrackLink(this);adobeClickReflektionWidget(this);" adobe_manual_cm_sp="recommeded for you | reflektion product">' + '<img src="'+ imagePresetSrc + '" title="' + productName + '">' + '</a>');					  
					}					
				}						
			}

						var showPrice = true;
			if (inStoreOnlyIndicator != undefined && inStoreOnlyIndicator != null && inStoreOnlyIndicator.toLowerCase() == 'yes'){
				if(bopusIndicator == undefined || bopusIndicator == null || bopusIndicator.toLowerCase() != 'yes') {
					showPrice = false;
				}				
			}
			if(showPrice) {
				var offerPriceVar = elementIdPrefix + elementIndex + "-price-promo";
				if($(offerPriceVar).length > 0){
					if(rfkwidgetControlParam == 'RD_DETAILS_PAGE' && rdPriceUSD != ""){
						$(offerPriceVar).html(rdPriceUSD);
						if(isRDEligible != undefined && isRDEligible != null && isRDEligible.toLowerCase() == 'yes'){
							var rdLogo = elementIdPrefix + elementIndex + "-price-rdrfk-logo";
							$(rdLogo).removeClass('hide');
						}
					}else{
						$(offerPriceVar).html(priceUSD);
						if(rfkwidgetControlParam == 'RD_DETAILS_PAGE' && isRDEligible != undefined && isRDEligible != null && isRDEligible.toLowerCase() == 'yes'){
							var rdLogo = elementIdPrefix + elementIndex + "-price-rdrfk-logo";
							$(rdLogo).removeClass('hide');
					}
					}
				}
				if(rfkwidgetControlParam != 'RD_DETAILS_PAGE'){
					var listPriceVar = elementIdPrefix + elementIndex + "-price-crossout";
					if(typeof(listpriceUSD) != 'undefined' && 
								((listpriceUSD.replace("$","")*1) > priceUSD.replace("$","")*1)){
						if($(listPriceVar).length > 0){
							$(listPriceVar).html('was ' + listpriceUSD);
						}					
					}

										var rdPriceVar = elementIdPrefix + elementIndex + "-price-rd";
					var rdPriceDiv = elementIdPrefix + elementIndex + "-price-rd-val";
					var rdLogo = elementIdPrefix + elementIndex + "-price-rd-logo";

										if(isRDEligible != undefined && isRDEligible != null && isRDEligible.toLowerCase() == 'yes') {					
						if($(rdPriceVar).length > 0){					
							$(rdPriceDiv).html(rdPriceUSD);
							$(rdPriceVar).show();
						} 
					} else {
						$(rdPriceDiv).html('');
						$(rdLogo).html('');		
						$(rdLogo).removeClass('rd-logo');
					}
				}
			} else {
				var rdPriceVar = elementIdPrefix + elementIndex + "-price-rd";
				var rdPriceDiv = elementIdPrefix + elementIndex + "-price-rd-val";
				var rdLogo = elementIdPrefix + elementIndex + "-price-rd-logo";
				$(rdPriceDiv).html('');
				$(rdLogo).html('');		
				$(rdLogo).removeClass('rd-logo');
			}
			var productNameTaggingElement =  rfkWidgetId + "-" + elementIndex + "-productName-tagging";
			var partNumberTaggingElement =  rfkWidgetId + "-" + elementIndex + "-partNumber-tagging";	
			var productIDTaggingElement =  rfkWidgetId + "-" + elementIndex + "-productId-tagging";	
			var productBrandTaggingElement =  rfkWidgetId + "-" + elementIndex + "-productBrand-tagging";
			var productPriceTaggingElement =  rfkWidgetId + "-" + elementIndex + "-productListPrice-tagging";

			if (document.getElementById(productIDTaggingElement)) { document.getElementById(productIDTaggingElement).value = selectedSwatch.sku_uid; }
			if (document.getElementById(productNameTaggingElement)) { document.getElementById(productNameTaggingElement).value = productName; }
			if (document.getElementById(partNumberTaggingElement)) { document.getElementById(partNumberTaggingElement).value = selectedSkuPartNumber; }
			if (document.getElementById(productBrandTaggingElement)) { document.getElementById(productBrandTaggingElement).value = brand; }
			if (document.getElementById(productPriceTaggingElement)) { document.getElementById(productPriceTaggingElement).value = listpriceUSD; }

			if(rfkEnableAddToCart == 'yes'){	
				if(rfkwidgetControlParam == 'RD_DETAILS_PAGE'){
					addToCartVar = elementIdPrefix + elementIndex + "-addToRD";	
				}
				else{
					addToCartVar = elementIdPrefix + elementIndex + "-addToCart";	
				}
				var showAddToCart = true;
				if(definingAttributesCount > 1) {
					showAddToCart = false;
				} else if (personalizedItemFlag != undefined && personalizedItemFlag != null && personalizedItemFlag.toLowerCase() == 'yes'){
					showAddToCart = false;
				} else if (rxFoodIndicator != undefined && rxFoodIndicator != null && rxFoodIndicator.toLowerCase() == 'yes'){
					showAddToCart = false;
				} else if (rxPharmaIndicator != undefined && rxPharmaIndicator != null && rxPharmaIndicator.toLowerCase() == 'rx medication pdp'){
					showAddToCart = false;
				} else if (inStoreOnlyIndicator != undefined && inStoreOnlyIndicator != null && inStoreOnlyIndicator.toLowerCase() == 'yes'){
					showAddToCart = false;
				}				
				if(rfkwidgetControlParam == 'RD_DETAILS_PAGE'){
					var addToCartBtn = rfkWidgetId + "-" + elementIndex + "-addToRdBtn";	
				}
				else{
					var addToCartBtn = rfkWidgetId + "-" + elementIndex + "-addToCartBtn";	

				}
				var  isRecentPurchaseContainerVertical = $('#'+rfkWidgetId + '-vertical-rfk-rec').parents("#recent-purchase-container").length;
				var  isRecentPurchaseContainerHorizontal = $('#'+rfkWidgetId + '-horizontal-rfk-rec').parents("#recent-purchase-container").length;
				var addToCartBtnPrefix = rfkWidgetId + "-" + elementIndex;
				if(showAddToCart) {					
					if($('select[id^="'+rfkWidgetId+'-'+productPartNumber+'"] option').size() > 1 && !isfromComboBoxFlag){
						$('select[id^="'+rfkWidgetId+'-'+productPartNumber+'"]').val("");
						if (isRecentPurchaseContainerVertical > 0 || isRecentPurchaseContainerHorizontal > 0) {
							$(addToCartVar).html('<a disabled="disabled" class="show rfladdTocartLink text-underLine" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</a>');
						} else {
							$(addToCartVar).html('<button disabled="disabled" class="btn btn-primary btn-full show rfladdTocartLink" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</button>');
						}
					} else{
						if (isRecentPurchaseContainerVertical > 0 || isRecentPurchaseContainerHorizontal > 0) {
							$(addToCartVar).html('<a class="show rfladdTocartLink text-underLine" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</a>');
						} else {
							if(rfkwidgetControlParam == 'RD_DETAILS_PAGE'){
								var subscriptionId = $('#subscriptionId').val();
								$('#elementPrefix').val(elementIdPrefix);								
								$(addToCartVar).html('<button class="btn btn-primary btn-full show rfladdTordLink" id="'+ addToCartBtn + '" onclick="MyAccountDisplay.rdAddOnLoginOptions(\''+subscriptionId+'\',\''+ elementIdPrefix+elementIndex + '\');adobeClickTrackLink(this);" adobe_manual_cm_sp="recommeded for you | add to repeat delivery" >Add to <p class="rd-rfk-button-logo"></p></button>');
							}
							else{
								$(addToCartVar).html('<button class="btn btn-primary btn-full show rfladdTocartLink" id="'+ addToCartBtn + '" onclick="petcoAddToCartJS.AddItem2ShopCartAjaxFromRecommendation(\''+selectedSkuPartNumber+'\',\''+ addToCartBtnPrefix + '\');">Add to Cart</button>');
							}
						}
					}					
				} else {	
					if (isRecentPurchaseContainerVertical > 0 || isRecentPurchaseContainerHorizontal > 0) {
						$(addToCartVar).html('<a  id="'+ rfkWidgetId+'-'+productPartNumber+'-viewdetails' + '" class="rflviewDetailsLink text-underLine" onclick="clickTrackLink(this);" href="'+ pdpURL +'" target="_parent">View Details</a>');		
					} else {
						$(addToCartVar).html('<a  id="'+ rfkWidgetId+'-'+productPartNumber+'-viewdetails' + '" class="rflviewDetailsLink" onclick="clickTrackLink(this);" href="'+ pdpURL +'" target="_parent"><button class="btn btn-primary btn-full rflViewDetailsLink show">View Details</button></a>');					
					}
				}				
			}

						if(typeof(page) != "undefined" && page != null){
				var pageName = page.page_type.split(" ").join("");
				var elementIdTitle = $("#" + rfkWidgetId +"-widgetTitle");
				var elementIdTitleval="";
				var ratingLink_1 = elementIdPrefix + elementIndex + "-rating-link";
				var imageLink_1=  elementIdPrefix + elementIndex + "-img a"; 
				var nameLink_1 = elementIdPrefix + elementIndex + "-name-link"; 
				var addtocartLink_1 = elementIdPrefix + elementIndex + "-addToCart .rfladdTocartLink";
				var viewDetailsLink_1 = elementIdPrefix + elementIndex + "-addToCart .rflviewDetailsLink";

				if(elementIdTitle.length > 0){
					elementIdTitleval=$(elementIdTitle).html();
					elementIdTitleval=elementIdTitleval.split(" ").join("");
					var fullText = pageName+"-_-"+elementIdTitleval+":"+elementIndex+"-_-"+selectedSkuPartNumber;
					$(ratingLink_1).attr("manual_cm_sp",fullText);
					$(imageLink_1).attr("manual_cm_sp",fullText);
					$(nameLink_1).attr("manual_cm_sp",fullText);

										if($(addtocartLink_1).length > 0){
						var fullText_addToCart = fullText + ":addtocart";
						$(addtocartLink_1).attr("manual_cm_sp",fullText_addToCart);
					}

										if($(viewDetailsLink_1).length > 0){
						$(viewDetailsLink_1).attr("manual_cm_sp",fullText);
					}					
				}
			}

						}

				function resetRecommendation(){
		}

				function parseProductDetails(product, rfkWidgetId, enableSkuSelection){			
			var selectedSwatch = {};			
			var attributes = {};
			var attributeValues = [];
			var definingAttributesCount = 0;
			var products = {};
			var productPartNumber = product.prod_partnumber;
			var productName = product.name;
			var brand = product.brand;
			var primarySKU = product.sku_partnumber;
			var swatches = {};
			var imgURL = product.image_url;
			var priceUSD = product.price_USD;
			var listpriceUSD =  product.listprice_USD;
			var rdPriceUSD = product.rd_price_USD;
			var reviewRating = product.review_rating;
			var reviewCount =  product.review_count;
			var isRDEligible = product.ptc_omni_repeat_delivery_fl;
			var pdpURL = product.url;
			var personalizedItemFlag = product.ptc_omni_personalized_item_fl;
			var rxFoodIndicator = product.ptc_omni_rx_food_ind;
			var rxPharmaIndicator = product.ptc_omni_pdp_behavior_template;
			var inStoreOnlyIndicator = product.ptc_omni_in_store_only_flag;
			if(recommendationParsedSkuDetails[rfkWidgetId] == undefined){
				recommendationParsedSkuDetails[rfkWidgetId] = {};
				recommendationParsedSkuDetails[rfkWidgetId].products = {};
			} else {
				if(recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber] == undefined){
					recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber] = {"attributes": {}};
				}
			}

									if(enableSkuSelection == 'yes') {
				swatches = product.swatch;
				if(swatches != undefined) {
					$.each(swatches, function(index,swatch){
						definingAttributesCount = 0;
				    	if(typeof(swatch['defining_attributes']) != 'undefined'){
				    		$.each(swatch['defining_attributes'],function(index,swatchLst){
				    			for(var key in swatchLst){
				    				var valValue = swatchLst[key];
				    				if(attributes[key] == undefined){
						    			attributeValues = [];
						    			attributeValues.push(valValue);
						    			attributes[key] = attributeValues;	
						    		} else {
						    			attributeValues = attributes[key] ;
						    			var valueExist = false;
						    			$.each(attributeValues, function(index,attributeValue){
						    				if(valValue == attributeValue){
						    					valueExist = true;				    					
						    				}
						    			});
						    			if(valueExist == false) {
						    				attributeValues.push(valValue);
						    				attributes[key] = attributeValues;

						    										    			}				    			
						    		}
				    			}
				    		})
				    	}
					    $.each(swatch, function(key,val){
					    	if(key == REFLEKTION_SKU_PARTNUM_FIELD) {
					    		if(val == primarySKU){
					    			selectedSwatch = swatch;
					    		}
					    	}			

					    						    });
					});				
				}		
			} else {
				swatches = product.swatch;
				if(swatches != undefined) {
					$.each(swatches, function(index,swatch){
					    $.each(swatch, function(key,val){
					    	if(key == REFLEKTION_SKU_PARTNUM_FIELD) {
					    		if(val == primarySKU){
					    			selectedSwatch = swatch;
					    		}
					    	}
					    });
					});
				}					    
			}



												for( var key in attributes){
				definingAttributesCount++;
			}
			recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber] = {"name": productName, "brand": brand, "review_rating": reviewRating ,"review_count": reviewCount, "url":pdpURL , "image_url":imgURL, "price_USD": priceUSD,"listprice_USD": listpriceUSD, "rd_price_USD":rdPriceUSD, "rd_eligible":isRDEligible, "attributes": attributes, "swatches": swatches, "primary_sku": primarySKU, "selected_swatch" : selectedSwatch, "defining_attr_count": definingAttributesCount,"personalizedItemFlag":personalizedItemFlag, "rxFoodIndicator":rxFoodIndicator,"rxPharmaIndicator":rxPharmaIndicator,"inStoreOnlyIndicator":inStoreOnlyIndicator};
		}

				function showReviewRating(rfkWidgetId, elementIndex, productPartNumber){	

						var elementIdPrefix = "#" + rfkWidgetId + "-";
			var rating = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].review_rating;	
			var reviewCount = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].review_count;
			var reviewRatingMainDiv =  elementIdPrefix + elementIndex + "-rating";			
			var reviewRatingLongBarDiv = elementIdPrefix + elementIndex + "-star_limiter  .longbar";

						var reviewRatingLinkElement = elementIdPrefix + elementIndex + "-rating-link";
			var reviewCountElement = elementIdPrefix + elementIndex + "-review-count";
			var reviewRatingLink = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].url + '#customerReviews';			
			var num_stars = 5;
			if(rating == undefined || rating == null){
				rating = 0;
			}
			if(reviewCount == undefined || reviewCount == null){
				reviewCount = 0;
			}
			if(!isNaN(rating)) {
				$(reviewRatingMainDiv).attr("title" , rating + "stars");
				var percent = Math.round( rating * 100 / num_stars);
				if(percent > 100) percent = 100;				
				$(reviewRatingLongBarDiv).width(percent + "%");

								if($(reviewRatingLinkElement).length > 0){
					$(reviewRatingLinkElement)[0].href = reviewRatingLink;	
				}
				$(reviewCountElement).html('(' + reviewCount + ')');
			}
		}
		function populateAttribute(rfkWidgetId, productPartNumber, elementIndex,definingAttributesCount){			
			var combobox;
			var option;
			var selectedValue;
			var selectedSwatch = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].selected_swatch;
			var attributes = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].attributes;
			var elementIdPrefix = "#" + rfkWidgetId + "-";
			var skuSelectionVar = elementIdPrefix + elementIndex + "-skuDetailsDiv";
			$(skuSelectionVar).addClass("select-style");
			$(skuSelectionVar).removeClass("select-attribute");			
			var shouldContinueShowing = true;
			if(definingAttributesCount > 0){
				var visibleHidden = false;
				$.each(attributes, function(key,val){	
					if(shouldContinueShowing){
					var comboboxId = rfkWidgetId + "-" + productPartNumber + "-" + key;
					if(typeof(selectedSwatch['defining_attributes']) != 'undefined'){
						selectedValue = selectedSwatch['defining_attributes'][0][key];
					}

										if(definingAttributesCount > 1){
						combobox = $("<select></select>").attr("id", comboboxId).attr("name", comboboxId).attr("class", "form-control disabled").attr("disabled","disabled");

												visibleHidden= true;
					}else{
						combobox = $("<select></select>").attr("id", comboboxId).attr("name", comboboxId).attr("class", "form-control");
					}
					combobox.attr("onchange", "ReflektionHelperJS.changeAttributeSelection('" + rfkWidgetId + "'," + productPartNumber + "," + elementIndex + ",this.value)");
					option =  $('<option />', {text: 'Select '+key, value: ''});
					combobox.append(option);
					$.each(val, function(index,attributeValue) {					
						if(selectedValue == attributeValue){
							option =  $('<option />', {text: attributeValue, value: attributeValue, selected: true});
						} else {
							option =  $('<option />', {text: attributeValue,value: attributeValue});
						}
						combobox.append(option);
					});
					if(definingAttributesCount > 1){
						shouldContinueShowing = false;
					}
				}
				});

								$(skuSelectionVar).append (combobox);
				if(visibleHidden){
					$(skuSelectionVar).css('visibility','hidden');
				}

							}else{
				var comboboxId = rfkWidgetId + "-" + productPartNumber + "-SELECT";
				var skuSelectionVar = elementIdPrefix + elementIndex + "-skuDetailsDiv";
				   $(skuSelectionVar).addClass("select-style");
				   $(skuSelectionVar).removeClass("select-attribute");
				   $(skuSelectionVar).html('<select id="'+comboboxId+'"  class="form-control disabled" disabled><option value=""> Select </option> </select>');
				   $(skuSelectionVar).css('visibility','hidden');
			}
		}

				function isDefiningAttribute(attributeName) {
			var isDefiningAttribute = false;
			$.each(DEFINING_ATTRIBUTE_LIST, function(index,definingAttribute){	
				if(attributeName == definingAttribute){
					isDefiningAttribute = true;
				}
			});			
			return isDefiningAttribute;
		}

				function changeAttributeSelection(rfkWidgetId, productPartNumber, elementIndex, selectedAttribute){
			var attributes = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].attributes;
			var productName = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].name;
			var selectedSwatch = {};
			var selectedAttributeKey = "";
			var selectedAttributeValue = "";
			if(typeof(attributes) != 'undefined') {
				$.each(attributes, function(index,swatch){
					$.each(swatch, function(key,val){
						if(val == selectedAttribute) {
							selectedAttributeKey = index;	
							selectedAttributeValue = val;
			    		}
					});
				});			

								if(selectedAttributeKey != "" && selectedAttributeValue != "") {
					var swatches = recommendationParsedSkuDetails[rfkWidgetId].products[productPartNumber].swatches;
					$.each(swatches, function(index,swatchKey){
						if(typeof(swatchKey['defining_attributes']) != 'undefined'){
				    		$.each(swatchKey['defining_attributes'],function(index,swatchLst){
				    			for(var key in swatchLst){
				    				if(selectedAttributeKey == key && selectedAttributeValue == swatchLst[key]){
				    					selectedSwatch = swatchKey;
				    				}
				    			}
				    		});
						}
					})
					if(Object.keys(selectedSwatch).length > 0) {
						renderProductDetails(rfkWidgetId, elementIndex, selectedSwatch, productPartNumber, true,true);
						$("#"+rfkWidgetId+"-"+elementIndex+"-addToCartBtn").removeAttr("disabled","disabled");
					}else{
						$("#"+rfkWidgetId+"-"+elementIndex+"-addToCartBtn").attr("disabled","disabled");
					}
				}else{
					$("#"+rfkWidgetId+"-"+elementIndex+"-addToCartBtn").attr("disabled","disabled");
				}
			}

						updateSolrPrice();
		}

				function enableRfkRecommendation(){	
			getReflektionEnabled();	
			var enableRecommendation = false;
			if(ENABLE_REFLEKTION){
				var rFKHeader=getCookie("RFKHeader");

								if(typeof(rFKHeader) != "undefined" && rFKHeader != null && rFKHeader == 'rfk' ){
					$("#ENABLE_REFLEKTION").val("true");
					enableRecommendation = true;
				} else{
					setCookie("RFKHeader", 'rfk');
					enableRecommendation = true;
					$("#ENABLE_REFLEKTION").val("true");
				}		
			}else{
				enableRecommendation = false;
				$("#ENABLE_REFLEKTION").val("false");
			}			
			return enableRecommendation;
		}
		function checkBeforeSearchSubmit(){
			var idEle = $("#SimpleSearchForm_SearchTerm");
			if(idEle.length > 0){
				if($(idEle).val().trim() == ""){
					return false;
				}else{
					return true;
				}
			}
		}
		function setCachedSuggestionsURL(url){
			CachedSuggestionsURL = getAbsoluteURL() + url;
		}
		function retrieveCachedSuggestions() {
			if(!ReflektionHelperJS.retrievedCachedSuggestions) {

								$.ajax({
					  method: "GET",
					  url: CachedSuggestionsURL,
					  dataType: "script"
					});




			 			 			 			}
		}
		function formSearchPreviewUrl(hrefVal){
			hrefVal = "//"+hrefVal;
			if(typeof(reflektionList) != 'undefined'){
				 var hrefArray = hrefVal.split("/");
				  var href = hrefArray[hrefArray.length -1];
				  var newUrl = reflektionList[href];
				  if(typeof(newUrl) != 'undefined' && newUrl != null && newUrl != ""){
					  return newUrl;
				  }else{
					  return hrefVal;
				  }
			}else{
				 return hrefVal;
			}
		}
		function setSearchSource(searchSource) {
			localStorage.setItem(SEARCH_SOURCE_KEY, searchSource);
		}
		function bopusAreaRestrictionCheck(){
			var  oNearestStores = JSON.parse(localStorage.getItem('petcostores'));
			var curstate = "";
			if(oNearestStores != null && Object.keys(oNearestStores).length != 0){
				 var petcoStoresLocation = {};
				 if(typeof(oNearestStores.petcostores) != "undefined"){
					 petcoStoresLocation =  JSON.parse(oNearestStores.petcostores) != null ? JSON.parse(oNearestStores.petcostores) : {};
					 var oNearestStore = petcoStoresLocation[0];
					 curstate = oNearestStore.STATE;
					 $("#CurrentBOPUSStateGlobal").val(curstate);
						if($("#isBOPUSAreaRestictionEnabeledTMP").length > 0 && $("#isBOPUSAreaRestictionEnabeledTMP").val() == 'true'){
							var states = "";
							if($("#BOPUSAreaRestictionStateTMP").length > 0){
								states = $("#BOPUSAreaRestictionStateTMP").val();
								var stateArray = states.split(",");
								for(var ix = 0 ; ix < stateArray.length ; ix++){
									if(stateArray[ix] == curstate){
										$(".hideBopusAreaRestriction p").html('In-Store Only');
										break;
									}
								}
							}
						}


					 					 				 }

							}
		}
		function recomentationPDPCall(rfkWidgetId,catEntryId,productId){
							for(var item in productDisplayJS.entitledItems){
								if(catEntryId == productDisplayJS.entitledItems[item].catentry_id){
									ReflektionHelperJS.setRfkRecommendationSKU(productDisplayJS.entitledItems[item].PartNum);

																		var isRfkCallRecCount=10;
									var isRfkCallRec = setInterval(function(){
										if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) == 'function'){
											   clearInterval(isRfkCallRec);
											   isRfkCallRecCount=10;
											   ReflektionHelperJS.rfkRecommendation_init(rfkWidgetId);					  
										}else if(isRfkCallRecCount == 0){
												clearInterval(isRfkCallRec);
											    isRfkCallRecCount=10;
												ReflektionHelperJS.rfkRecommendation_init(rfkWidgetId);							 
										}else{
											isRfkCallRecCount--;
										}
									}, 200);


																										}
							}


													}
		function recomentationNoNPDPCall(rfkWidgetId){
				var isRfkCallRecCount=10;
				var isRfkCallRec = setInterval(function(){
					if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) == 'function'){
						   clearInterval(isRfkCallRec);
						   isRfkCallRecCount=10;
						   ReflektionHelperJS.rfkRecommendation_init(rfkWidgetId);					  
					}else if(isRfkCallRecCount == 0){
							clearInterval(isRfkCallRec);
						    isRfkCallRecCount=10;
							ReflektionHelperJS.rfkRecommendation_init(rfkWidgetId);							 
					}else{
						isRfkCallRecCount--;
					}
				}, 200);
		}

		function recommendationNoNPDPBatchCall(parentWidgetId){

					var isRfkBatchCallRecCount=10;
			var isRfkBatchCallRec = setInterval(function(){
				if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) == 'function'){
					   clearInterval(isRfkBatchCallRec);
					   isRfkBatchCallRecCount=10;						   
					   ReflektionHelperJS.rfkRecommendation_initBatch(parentWidgetId);					  
				}else if(isRfkBatchCallRecCount == 0){
					   clearInterval(isRfkBatchCallRec);
					   isRfkBatchCallRecCount=10;
						ReflektionHelperJS.rfkRecommendation_initBatch(parentWidgetId);							 
				}else{
					isRfkBatchCallRecCount--;
				}
			}, 200);			

							}

				function rfkRecommendation_initBatch(parentWidgetId){			

						var recommendationDataForRfkCall = prepareDataForRecommendationNoNPDPBatchCall(parentWidgetId);
			if(recommendationDataForRfkCall.widgetArr != undefined){

								if(enableRfkRecommendation()) {
					var batchRecommendationCall = setInterval(function(){ 		
						if(IS_KEY_RETRIVED){
							callRfkRecommendationEngineForWidgetBatch(recommendationDataForRfkCall);
							clearInterval(batchRecommendationCall);
						}
					}, 100);
				}
			}

		}

				function prepareDataForRecommendationNoNPDPBatchCall(parentWidgetId){


						var recommendationDataForRfkCall = {};

						var rfkMaxNumberOfProductToDisplay = 0;

						var rfkSkus = [];
			if($("#rfkRecommendationPartNumber").length > 0){
				rfkSkus = $("#rfkRecommendationPartNumber").val().split(',');
			}

						var recommendationWidgetArr = [];
			$("input[name='rfkWidgetId']" ).each(function(index) {

				 				  var widgetId = $(this).val();
				  var isWidgetProcessed = false;

				  $.each(recommendationWidgetProcessed.split(','), function(index, processedWidgetId) {						
							if(processedWidgetId == widgetId){
							      isWidgetProcessed = true;							      						      
							      return false;
						    }			
					});		

				  if(isWidgetProcessed == true){
					  return true;
				  }
				  else{
					  if(recommendationWidgetProcessed == ""){
						  recommendationWidgetProcessed = widgetId;
					  }
					  else{
						  recommendationWidgetProcessed = recommendationWidgetProcessed + "," + widgetId; 
					  }
				  }

				  				  var rfkWidgetName = $("#" + widgetId + "-" + "rfkWidgetName").val();
				  var rfkTitleWidgetName = $("#" + widgetId + "-" + "rfkTitleWidgetName").val();

                 				  var rfkNumberOfProduct = $("#" + widgetId + "-" + "rfkNoOfProducts").val();
				  if(parseInt(rfkNumberOfProduct) > rfkMaxNumberOfProductToDisplay){
					  rfkMaxNumberOfProductToDisplay = parseInt(rfkNumberOfProduct);
				  }
                  var rfkWidgetControlParam = $("#" + widgetId + "-" + "rfkwidgetControlParam").val();
                  var recommendationWidget = {};				
				  recommendationWidget.widgetId = widgetId;
				  recommendationWidget.rfkWidgetName = rfkWidgetName;
				  recommendationWidget.rfkTitleWidgetName = rfkTitleWidgetName;
				  recommendationWidget.rfkWidgetControlParam = rfkWidgetControlParam;
				  recommendationWidgetArr.push(recommendationWidget);

				  			 });		

						if(recommendationWidgetArr.length == 0){
				return recommendationDataForRfkCall;
			}


									recommendationDataForRfkCall.widgetArr = recommendationWidgetArr;
			recommendationDataForRfkCall.rfkSkus = rfkSkus;
			recommendationDataForRfkCall.rfkNumberOfProductToDisplay = rfkMaxNumberOfProductToDisplay;

						return recommendationDataForRfkCall;
		}

				function callRfkRecommendationEngineForWidgetBatch(recommendationDataForRfkCall){

						var URL = "//"+REFLEKTION_API_URL_HOST;

						var sendRecommendationRequest = true;


											$.each(recommendationDataForRfkCall.widgetArr, function(index, recommendationWidget) {						
				if(recommendationWidget.rfkWidgetControlParam == 'CART' || recommendationWidget.rfkWidgetControlParam == 'OCP'|| recommendationWidget.rfkWidgetControlParam == 'RD_DETAILS_PAGE'){
					rfkRecommendationRequest.data.context.page.sku = [];				
					rfkRecommendationRequest.data.context.page.sku = recommendationDataForRfkCall.rfkSkus;
			    }
				else if(recommendationWidget.rfkWidgetControlParam == 'UID'){

									}
                else{
                	sendRecommendationRequest = false;
                	return false;
			    } 
		   });

						if(sendRecommendationRequest == true && recommendationDataForRfkCall.rfkNumberOfProductToDisplay != undefined && recommendationDataForRfkCall.rfkNumberOfProductToDisplay != ""){
				rfkRecommendationRequest.data.n_item = recommendationDataForRfkCall.rfkNumberOfProductToDisplay;
			}
			else{
				sendRecommendationRequest = false;
			}

						if(sendRecommendationRequest == true && recommendationDataForRfkCall.widgetArr != undefined && recommendationDataForRfkCall.widgetArr.length > 0){
				 rfkRecommendationRequest.data.batch = [];			 
				 $.each( recommendationDataForRfkCall.widgetArr , function( index, recommendationWidget ){

					 				 					  var rfkRecommendationWidgetVal = {};

					  					  if(recommendationWidget.rfkWidgetName != undefined && recommendationWidget.rfkWidgetName.length > 0){
						  rfkRecommendationWidgetVal.widget = {};
						  rfkRecommendationWidgetVal.widget.rfkid = recommendationWidget.rfkWidgetName;
						  rfkRecommendationRequest.data.batch.push(rfkRecommendationWidgetVal);	  
					  }

					  					  if(recommendationWidget.rfkTitleWidgetName != undefined && recommendationWidget.rfkTitleWidgetName.length > 0){
						  rfkRecommendationWidgetVal = {};
						  rfkRecommendationWidgetVal.widget = {};
						  rfkRecommendationWidgetVal.widget.rfkid = recommendationWidget.rfkTitleWidgetName;
						  rfkRecommendationRequest.data.batch.push(rfkRecommendationWidgetVal);	  
					  }

					  				  				 });
			}
			else{
				sendRecommendationRequest = false;
			}


						 						 var uuid="RFK_UUID";
        	 if(typeof(rfk)!= 'undefined' && rfk != null && typeof(rfk.uid) != 'undefined' && typeof(rfk.uid) == 'function'){
        		uuid = rfk.uid();
        	 }	        	
        	rfkRecommendationRequest.data.context.user.uuid = uuid; 

        	        	if(sendRecommendationRequest) {
				$.ajax({
					url : URL,
					type: 'POST',
					dataType : 'json',
					headers: {"Authorization": "Bearer "+REFLEKTION_ACCESS_TOKEN},
					timeout : REFLEKTION_API_TIMEOUT,
					beforeSend : function(xhr){ 
						xhr.setRequestHeader('Content-Type', 'application/json');     
					}, 
					data: JSON.stringify(rfkRecommendationRequest),
					success : function(dataVal) {
						if(typeof(dataVal) != 'undefined' ){
						    loadRfkRecommendationWidgetsInBatch(dataVal, recommendationDataForRfkCall);
						    ReflektionHelperJS.bopusAreaRestrictionCheck();
						} else {
							console.log("invalid response from RFK");
						}
					},
					error : function(jqXHR, errorType, exception) { 
						logErrorFromReflektion(jqXHR, errorType, exception);
						resetRecommendation();       
					},
					complete: function(dataVal,textStatus ){
						triggerWidgetCallInBatch(dataVal,textStatus,recommendationDataForRfkCall);
					}     
				});
			}
		}

				function loadRfkRecommendationWidgetsInBatch(rfkResponseForRecommendationCall, recommendationDataForRfkCall){

						$.each( recommendationDataForRfkCall.widgetArr , function( index, recommendationWidget ){

								var jsonObject={};
				var jsonObjectTitle={};

								var rfkRecWidgetId = recommendationWidget.widgetId;
				var rfkRecWidgetName = recommendationWidget.rfkWidgetName;
				var rfkRecWidgetTitleName = recommendationWidget.rfkTitleWidgetName;	

								for(var i in rfkResponseForRecommendationCall.batch){
					var widgetId = rfkResponseForRecommendationCall.batch[i].widget.rfkid;

										if(widgetId == rfkRecWidgetName ){
						jsonObject = rfkResponseForRecommendationCall.batch[i];
					}else if(widgetId == rfkRecWidgetTitleName){
						jsonObjectTitle  = rfkResponseForRecommendationCall.batch[i];
					}
					}

								if(typeof(jsonObject.content) == 'undefined' || typeof(jsonObject.content.product) == 'undefined'){
					return true;
				}

								var elementIdPrefix = "#" + rfkRecWidgetId + "-";
				$('select[id^="'+rfkRecWidgetId+'-"]').remove();
				var widgetTitleVar = elementIdPrefix + 'widgetTitle';
				var carouselPrev = elementIdPrefix + 'prev';
				var carouselNext = elementIdPrefix + 'next';
				var rfkEnableSkuSelectionVar = elementIdPrefix + "rfkEnableSkuSelection";
				var rfkEnableSkuSelection;
				if($(rfkEnableSkuSelectionVar).length > 0){
					rfkEnableSkuSelection = $(rfkEnableSkuSelectionVar).val();
				}

								if(typeof(jsonObjectTitle) != 'undefined' && typeof(jsonObjectTitle.appearance) != 'undefined'
					&& typeof(jsonObjectTitle.appearance.variables) != 'undefined' && typeof(jsonObjectTitle.appearance.variables.title) != 'undefined'){
					var classes = jsonObjectTitle.appearance.css_names;
					$(classes).each(function(i,obj){
						$(widgetTitleVar).addClass(obj);
					})
					var variables = jsonObjectTitle.appearance.variables;
					var text_color = variables["text-color"].value;
					if(text_color != ""){
						$(widgetTitleVar).css( "color", text_color);
					}

										var title = variables.title.value;
					if(title != ""){
						$(widgetTitleVar).html(title);
					}
				}

								var recommendedSkuCount =  parseInt(jsonObject.n_item);
				var numberOfProductToDisplay = $(elementIdPrefix + 'rfkNoOfProducts').val();
				if(recommendedSkuCount > 0) {
					$(widgetTitleVar).show();			
					var definingAttributesCount = 0;
					for(var productIndex in jsonObject.content.product.value){
						elementIndex = parseInt(productIndex) + 1;			
						if(elementIndex <= numberOfProductToDisplay){
							prodMainDiv = elementIdPrefix + elementIndex;
							$(prodMainDiv).show();	
							parseProductDetails(jsonObject.content.product.value[productIndex], rfkRecWidgetId, rfkEnableSkuSelection);
							var productPartNumber = jsonObject.content.product.value[productIndex].prod_partnumber;
							var selectedSwatch = recommendationParsedSkuDetails[rfkRecWidgetId].products[productPartNumber].selected_swatch;
							renderProductDetails(rfkRecWidgetId, elementIndex, selectedSwatch, productPartNumber, false);
						}	
					}

										showOrHideContainer(rfkRecWidgetId, true);					

										if(numberOfProductToDisplay > 3) {
						if($(carouselPrev).length > 0) {
							$(carouselPrev).css({'display':'block'})
						}
						if($(carouselNext).length > 0) {
							$(carouselNext).css({'display':'block'})
						}					
					}
				}
				else{
				}			

							});

					}


				return{
			 	reflektion_init: reflektion_init,
			 	autoComplete_init: autoComplete_init,
			 	autoComplete_removeCommaBeforeSubmit: autoComplete_removeCommaBeforeSubmit,			 	
			 	generateReflektionAutoCompleteUrl:generateReflektionAutoCompleteUrl,
			 	setRfkRecommendationSKU:setRfkRecommendationSKU,
			 	RECOMMENDATION_PDP_SKU:RECOMMENDATION_PDP_SKU,
			 	rfkRecommendation_init: rfkRecommendation_init,
				changeAttributeSelection:changeAttributeSelection,
				checkBeforeSearchSubmit:checkBeforeSearchSubmit,
				setCachedSuggestionsURL:setCachedSuggestionsURL,
				retrievedCachedSuggestions:retrievedCachedSuggestions,
				setSearchSource:setSearchSource,
				bopusAreaRestrictionCheck:bopusAreaRestrictionCheck,
				recomentationPDPCall:recomentationPDPCall,
				recomentationNoNPDPCall:recomentationNoNPDPCall,
				recommendationNoNPDPBatchCall:recommendationNoNPDPBatchCall,
				rfkRecommendation_initBatch:rfkRecommendation_initBatch,
				widgetsFiredForRecommetnaions:widgetsFiredForRecommetnaions
			 };
	})();



			}